import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Injectable,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { Reservation } from "@interfaces/reservation";
import { VwReservation } from "@interfaces/dws/reservation";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { format, isSameDay, parse, parseISO } from "date-fns";
import { formatUtcTimestampLocal, formatUtcTimestampRome } from "@util/utc-timestamp";
import { Tag } from "@interfaces/tag";
import { confirm, ConfirmComponent } from "@web/app/components/dialogs/confirm";
import { tr } from "@util/tr/tr";
import { marker } from "@biesbjerg/ngx-translate-extract-marker";
import { ReservationsService } from "@services/reservations.service";
import {
  BehaviorSubject,
  defer,
  forkJoin,
  fromEvent,
  Observable,
  of,
  ReplaySubject,
  Subject,
  throwError,
  timer,
} from "rxjs";
import { MatAutocompleteTrigger } from "@angular/material/autocomplete";
import {
  catchError,
  debounce,
  debounceTime,
  delay,
  filter,
  finalize,
  first,
  distinctUntilChanged,
  map,
  pluck,
  share,
  startWith,
  switchMap,
  take,
  takeUntil,
  tap,
} from "rxjs/operators";
import { Router } from "@angular/router";
import * as moment from "moment";
import { Moment } from "moment";
import * as _ from "lodash";
import { Client } from "@interfaces/client";
import { toast } from "@web/util/toast";
import { GiftsService } from "@services/dws/gifts.service";
import { MatDialog } from "@angular/material/dialog";
import { MatSidenav } from "@angular/material/sidenav";
import { ExperienceAvailabilitiesService } from "@services/experience-availabilities.service";
import { ExperienceAvailability, ExperienceAvailabilityForDay } from "@interfaces/experience-availability";
import { MatDatepicker, MatDatepickerInputEvent } from "@angular/material/datepicker";
import { LoadingComponent } from "@web/app/components/loading/loading.component";
import { AccountsService } from "@services/accounts.service";
import { evaluateReservationDetailPermissionGroups } from "@services/permissions/permission-reservation-calendar.helper";
import { PermissionResolverService } from "@services/permissions/permission-resolver.service";
import { observe } from "@web/util/loading/loading";
import { Host } from "@interfaces/host";
import {
  CashRegisterService,
  ContactsService,
  ContactsTagsService,
  ExternalCalendarSyncService,
  LanguagesService,
  PaymentMethodsService,
  ReservationContactsService,
  StatisticsService,
  DWSLanguagesService,
  SyncHelperService,
} from "@services/dws";
import { DWS } from "@interfaces/dws";
import { locale } from "@util/locale";
import { HostReservationFormOptionsService } from "@services/host-reservation-form-options/host-reservation-form-options.service";
import { HostReservationFormOptions } from "@services/host-reservation-form-options/host-reservation-form-options";
import { ReservationDetail } from "@services/dws/scheduling/reservation-detail/reservation-detail";
import { ReservationDetailService } from "@services/dws/scheduling/reservation-detail/reservation-detail.service";
import { CurrencyPipe, getCurrencySymbol } from "@angular/common";
import { TranslateDomainPipe } from "@web/app/pipes/translate/translate-domain.pipe";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AvailabilityBlock } from "@interfaces/dws/availability-block";
import { NoticeComponent } from "@web/app/components/dialogs/notice/notice.component";
import { AvailabilityBlockService } from "@services/dws/availability-block.service";
import { ExperienceAvailabilityService } from "@services/dws/experience-availability.service";
import { TranslateService } from "@ngx-translate/core";
import { ExperienceAvailability as ExperienceAvailability2 } from "@interfaces/dws/experience-availabilities";
import { ExperiencePriceLabel } from "@interfaces/experience-price-label";
import { ExperiencePriceExtra } from "@interfaces/experience-price-extra";
import {
  captionFromLangMap,
  englishSlotText,
  fillTitleSlotsFromMergedMap,
  langMapFromPriceRow,
  langMapFromTranslationsBlob,
  normalizeLangIso,
  priceCaptionPickOrder,
} from "@interfaces/experience-price-title-slots";
import { ManualReservationRequestsListenerService } from "@services/manual-reservation-requests-listener.service";
import { ReservationComponent } from "@web/app/components/dialogs/reservation/reservation.component";
import MappedStatus = Reservation.MappedStatus;
import Company = Host.Company;
import { GiftDetailComponent } from "../dialogs/gift-detail/gift-detail.component";
import { ExperienceSlots } from "@interfaces/dws/experience-slots";
import { ReservationDTO } from "@interfaces/dws/reservation";
import { ContactAssociationComponent } from "../dialogs/contact-association/contact-association.component";
import { DWSFormOptions, ExperienceDWS } from "@interfaces/dws/experience-dws";
import { ExperienceEventsAvailabilitiesService } from "@services/dws/experience-events-availabilities.service";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { InfoIconHoverableComponent } from "../info-icon-hoverable/info-icon-hoverable.component";
import { Page } from "@interfaces/dws/page";
import { Contact } from "@interfaces/dws/contact";
import { PaymentLinkDialogComponent } from "../dialogs/payment-link-dialog/payment-link-dialog.component";
import { WSPaymentEmbedDialogComponent } from "../dialogs/payment-link-dialog/ws-payment-embed-dialog.component";
import { WSPaymentsService } from "@services/dws/ws-payments.service";
import { Payment, PaymentLink } from "@interfaces/dws/payment";
import { PaymentsPaymentDetailDialogService } from "@web/app/pages/payments/payments-payment-detail-dialog/payments-payment-detail-dialog.component";
import { WsPaymentItem } from "@web/app/pages/payments/payments-list-tab/payments-list-tab.component";
import { WineryIntegrationsService } from "@services/dws/winery-integrations.service";
import { WineryIntegration } from "@interfaces/dws/integration";
import { AvailabilityAutomationDialogComponent } from "../dialogs/availability-automation/availability-automation.component";
import { RevokeReservationDialogComponent, RevokeReservationDialogResult } from "../dialogs/revoke-reservation-dialog/revoke-reservation-dialog.component";
import { RefundPaymentDialogComponent } from "../dialogs/refund-payment-dialog/refund-payment-dialog.component";
import { ca } from "date-fns/locale";
import { HostCouponsService } from "@services/host-coupons.service";
import { IntegrationSyncMetadata, IntegrationEntityTypes } from "@interfaces/integration-sync-metadata";
import {
  getMissingCommercialDocumentPaymentFields,
  hasCommercialDocumentPaymentBlockers,
  isMissingPaymentSyncError,
  missingPaymentSyncFailureBody,
} from "@services/dws/receipt-payment-validation.util";
import { isSyncActionSuccess } from "@services/dws/sync-action-result.util";
import { SyncButtonConfig } from "@services/dws/sync-helper.service";
import { environment } from "@env/environment";
import { QrcodeOrSendLinkDialogComponent } from "../dialogs/qrcode-or-send-link/qrcode-or-send-link.component";
import { Translation } from "@interfaces/translation";
import { ExperienceAvailability as ExperienceAvailabilityDWS } from "@interfaces/dws/experience-availabilities";
import { InvoiceDataDialogComponent } from "../dialogs/invoice-data/invoice-data.component";
import { invoiceCompanyOnlyKeys, invoiceKeyNames, invoicePersonOnlyKeys } from "../../constants/invoice.constants";
import { FailedPaymentComponent } from "../dialogs/failed-payment/failed-payment.component";
import { ManageEmailSendingComponent } from "@web/app/components/dialogs/manage-email-sending/manage-email-sending.component";

marker("Are you sure you want to save the changes?");
marker("By leaving now you will lose all the changes made to the reservation.");
marker("Save");
marker("Leave");
marker("Back");
marker("Reservation created.");
marker("Reservation updated.");
marker("There was a problem saving the reservation. Try again later.");
marker("Are you sure you want to delete the reservation?");
marker("Reservation deleted successfully.");
marker("There was a problem deleting the reservation. Try again later.");
marker("Employee");
marker("Another update operation is running");
marker("Processing. Please do not close the browser or refresh the page...");
marker("Refund");
marker("You are about to refund a revoked reservation. This will process a refund for the DWSPay payment. Do you want to proceed?");
marker("Refund processed successfully");
marker("Refunded amount");
marker("View payment details");
marker("receipt.missingPaymentForCommercialDocument");
marker("receipt.missingPaymentMode");
marker("receipt.missingPaymentMethod");
marker("receipt.missingPaid");
marker("receipt.unsavedPaymentForCommercialDocument");
marker("View payment details");

interface EditClientRequest {
  client?: Client;
  callback: (client: Client) => void;
}

@Component({
  selector: "web-datepicker-empty-header",
  styles: [],
  template: ``,
})
export class DatePickerEmptyHeaderComponent {}

const experienceTypeCodes = ["tasting", "stay", "event", "special", "smart"];

@Component({
  selector: "app-reservation-detail",
  templateUrl: "./reservation-detail.component.html",
  styleUrls: ["./reservation-detail.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReservationDetailComponent implements OnInit, OnChanges, OnDestroy {
  emptyHeader = DatePickerEmptyHeaderComponent;
  isConfirmedReservation = false;
  tagsPopoverVisibility = false;
  reservationContactToEditId?: number | string;

  @ViewChild("trigger") trigger: any = MatAutocompleteTrigger;
  @Output() closeClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() reservationUpdated = new EventEmitter<ReservationDTO>();
  @Input() reservationId?: string;
  reservation?: ReservationDTO;
  @Input() reservationToClone?: ReservationDTO;
  @Input() isNewReservationFromCalendar: boolean = false;
  @Input() isTourOperator: boolean = false;
  @Output() addClient: EventEmitter<EditClientRequest> = new EventEmitter<EditClientRequest>();

  /** Minimum typed characters before calling contacts search (master + secondary client fields). */
  readonly clientSearchMinChars = 3;

  // Performance optimization properties
  private destroy$ = new Subject<void>();
  private _cachedCountForExperience: ExperienceAvailability2 | undefined;
  private _lastCountCacheKey: string = "";
  private _cachedExperienceName: Map<string, string> = new Map();
  private _cachedTranslatedName: Map<string, string> = new Map();

  companyInt?: Host.Company;
  dwspayIntegration?: WineryIntegration;
  saveDisabled = false;
  languages: DWS.Language[] = [];
  messageError = "An error occurred. Try later or contact support team.";

  availability: { count: number; max: number } = { count: 0, max: 0 };

  contactsData: Record<
    number | string,
    {
      contactStatistics: DWS.Statistic;
      contactTags: DWS.ContactTag[];
      contactPrivacy: {
        acceptedPrivacyTerms?: boolean;
        acceptedMarketing?: boolean;
        acceptedProfiling?: boolean;
        manualMarketing?: boolean;
        unsubscribed?: boolean;
      };
    }
  > = {};
  contactDetailOpen: Record<number | string, boolean> = {};
  contactsNotMatchingAlerts: Record<number | string, { [key: string]: string }> = {};

  private _experience: ExperienceDWS | undefined;
  @Output()
  experienceChange: EventEmitter<ExperienceDWS> = new EventEmitter<ExperienceDWS>();

  manualOrigins: HostReservationFormOptions.ManualOrigin[] = [];

  @Input() byGift?: boolean;
  @Output() returnGift: EventEmitter<boolean> = new EventEmitter<boolean>();
  availabilities2: ExperienceAvailability2[] = [];

  paymentLinkData: PaymentLink | null = null;
  dwspayPaymentRecord: Payment | null = null;
  private refreshingPaymentState = false;
  resCashRegisterMetadata: IntegrationSyncMetadata | undefined = undefined;
  regCashIntegrated = false;
  syncButtons: any[] = [];
  /** WS-3360: red outline on Terms of payment after blocked commercial-document emit. */
  missingPaymentModeHighlight = false;
  /** WS-3360: red outline on Method of payment after blocked commercial-document emit. */
  missingPaymentMethodHighlight = false;
  /** WS-3360: highlight Paid checkbox after blocked commercial-document emit. */
  missingPaidHighlight = false;
  /** WS-4003: inline errors on required booking fields after save or save draft. */
  reservationFieldErrorsVisible = false;

  @Input() set experience(v: ExperienceDWS | undefined) {
    this._experience = v;
    this.experienceChange.emit(v);
    this.experienceChanged();
  }

  availableExperiences: ExperienceDWS[] = [];
  availableExperiencesActive: ExperienceDWS[] = [];
  filteredExperiences: ExperienceDWS[] = [];
  private _experienceSearchTerm: string = "";
  availableLanguages: HostReservationFormOptions.Language[] = [];
  availableVisitReasons: HostReservationFormOptions.VisitReason[] = [];
  availableTimes: string[] = [];
  availableSlots: ExperienceSlots[] = [];
  availableAvailabilities: ExperienceAvailabilityDWS[] = [];
  availabilities: ExperienceAvailabilityForDay[] = [];
  availabilitiesBlock: HostReservationFormOptions.AvailabilityBlock[] = [];

  allTags: Tag[] = [];

  loadingClients: boolean = false;
  /** True while resolving CRM + form after closing the new/edit contact sidenav (WS-2420). */
  loadingContactAdd = false;
  private contactAddFlowPending = false;
  loadingCoupons: boolean = false;
  showCouponToggle: boolean = true; // Tracks the switch state for coupon/gift toggle

  company!: Company;
  isDraft = false;
  isDraftable = false;

  formPatched = true;

  eventDates: string[] = [];

  paymentMethods: HostReservationFormOptions.PaymentMethod[] = [];

  company$ = new ReplaySubject<Company>(1);
  rooms$ = new ReplaySubject<HostReservationFormOptions.Room[]>(1);
  rooms: HostReservationFormOptions.Room[] = [];
  employees$ = new ReplaySubject<HostReservationFormOptions.Employee[]>(1);

  language = "";

  companyId$ = new ReplaySubject<string>(1);
  companyId: string = "";
  cameFromCalendar: boolean = false;

  hasAnyAvailabilityForDateDay = false;

  hasEnabledAutomations = false;
  shouldAskForSlotClosing = true;
  isConfirmingOrRejecting = false;
  team: HostReservationFormOptions.Employee[] = [];
  countries: HostReservationFormOptions.Country[] = [];
  private availableCouponsSubject = new BehaviorSubject<Host.Coupon.Data[]>([]);
  availableCoupons$ = this.availableCouponsSubject.asObservable();
  private _availableCoupons: Host.Coupon.Data[] = [];
  get availableCoupons(): Host.Coupon.Data[] {
    return this._availableCoupons;
  }
  set availableCoupons(val: Host.Coupon.Data[]) {
    this._availableCoupons = val || [];
    this.availableCouponsSubject.next(this._availableCoupons);
    this.calculateDiscountValue();
    this.cdr.markForCheck();
  }
  clients: DWS.Contact[] = [];

  clientForm!: FormGroup;
  clientSaveCallback: (client: Client) => void = () => {};
  @ViewChild("clientSideNav") clientSideNav!: MatSidenav;

  compareId = (a: { id: any }, b: { id: any }) => {
    if (!a && !b) return true;
    if ((a && !b) || (!a && b)) return false;
    return a.id == b.id;
  };

  compareExperience = this.compareId;
  compareTag = this.compareId;
  compareRoom = this.compareId;
  compareEmployee = this.compareId;
  compareManualOrigin = this.compareId;
  comparePaymentMethod = this.compareId;
  objectKeys = (obj: any) => {
    return obj ? Object.keys(obj) : [];
  };

  editable!: ReservationDetail;
  form!: FormGroup;
  clients$!: Observable<DWS.Page<DWS.Contact>>;
  masterClients$!: Observable<DWS.Page<DWS.Contact>>;

  giftAssociatedBeforeRevocation: string | undefined;
  isCreatingPaymentLink = false;
  paymentRefunded = false;
  refundDate: Date | undefined;
  dwspayPaymentLoading = false;
  paymentRefundStatusLoading = false;
  private mustCallsLoaded = false;
  private dwspayPaymentUiTracking = false;
  private initialPageLoadActive = true;

  temporaryFormValues: { [key: string]: any } = {};

  gift: DWS.Gift | undefined;

  getContactCountryIso(id: number | string) {
    return (this.form.get("reservation")?.get("reservationContacts") as FormArray)?.controls.find((c) => c.get("id")?.value == id)?.value.countryIso;
  }

  get experiencePriceLabelsFormArray(): FormArray {
    return this.form.get("reservation")?.get("experience_price_labels") as FormArray;
  }

  get experiencePriceExtrasFormArray(): FormArray {
    return this.form.get("reservation")?.get("experience_price_extras") as FormArray;
  }

  get paidOnline() {
    return !(
      this.reservation?.paid == null ||
      this.reservation?.paid == false ||
      this.reservation?.netTotalCents == null ||
      this.reservation?.netTotalCents == 0
    );
  }

  get formArrayPriceLabels() {
    return this.experiencePriceLabelsFormArray.controls as FormGroup[];
  }

  get formArrayPriceExtras() {
    return this.experiencePriceExtrasFormArray.controls as FormGroup[];
  }

  get experience(): ExperienceDWS | undefined {
    return this._experience;
  }
  set loading(v: boolean) {
    LoadingComponent.loading = v;
  }

  searchControl: FormControl = new FormControl();
  masterSearchControl: FormControl = new FormControl();

  get canEdit(): boolean {
    return !this.reservation || this.reservation.type === "manual" || !this.completed;
  }

  get canEditCoreInfo(): boolean {
    return !this.reservation;
  }

  // TODO
  get canEditPaymentInfo(): boolean {
    return !this.reservation || !this.completed;
  }

  get waiting(): boolean {
    return this.reservation?.state === "waiting";
  }

  get confirmed(): boolean {
    return this.reservation?.state === "confirmed";
  }

  get completed(): boolean {
    return this.reservation?.state === "completed";
  }

  get isGift(): boolean {
    return !!this.reservation && !!this.reservation?.giftId;
  }

  get currencySymbol() {
    return getCurrencySymbol(this.reservation?.paymentCurrency || "EUR", "wide", undefined) || ("" as string);
  }

  get isAvailabilityBlock() {
    const date = this.reservation?.date || this.extractDateString(this.form.get("reservation")?.get("date")?.value);
    const time = moment(this.reservation?.time || this.form.get("reservation")?.get("time")?.value, "HH:ss").format("HH:ss:mm");
    if (!this.availabilitiesBlock) return undefined;
    return this.availabilitiesBlock.find((ab) => ab.date === date && ab.time === time && ab.closeSlots);
  }

  get isLanguageBlock() {
    const date = this.reservation?.date || this.extractDateString(this.form.get("reservation")?.get("date")?.value);
    const time = moment(this.reservation?.time || this.form.get("reservation")?.get("time")?.value, "HH:ss").format("HH:ss:mm");
    if (!this.availabilitiesBlock) return undefined;
    return this.availabilitiesBlock.find((ab) => ab.date === date && ab.time === time && !!ab.languageIso);
  }

  get reservationNotWaitingOrDraft() {
    return this.reservation && this.reservation.state !== "waiting" && this.reservation.state !== "draft";
  }

  get currentUrl() {
    return this.router.url.includes("/dashboard");
  }

  get isManualReservation() {
    return !this.reservation || this.reservation.type === "manual";
  }

  get lang() {
    try {
      return this.dwsLanguagesService.getCurrentLanguageIso();
    } catch (error) {
      console.warn("Error getting current language, falling back to locale:", error);
      return locale()?.locale || "en";
    }
  }

  /**
   * Get translated name with fallback support
   * @param item Object with nameTranslations property
   * @returns Translated name or fallback value
   */
  getTranslatedName(item: any): string {
    if (item?.code === "dwspay") {
      return tr("WineSuite Payments");
    }

    if (!item || !item.nameTranslations) {
      return item?.name || "";
    }

    // Ensure cache is initialized
    if (!this._cachedTranslatedName) {
      this._cachedTranslatedName = new Map();
    }

    // Create cache key
    const cacheKey = `${item.id || item.name}_${this.lang}`;

    // Return cached result if available
    if (this._cachedTranslatedName.has(cacheKey)) {
      return this._cachedTranslatedName.get(cacheKey)!;
    }

    const currentLang = this.lang;
    const result = (
      item.nameTranslations[currentLang] ||
      item.nameTranslations["en"] ||
      item.nameTranslations["it"] ||
      item.name ||
      ""
    );

    this._cachedTranslatedName.set(cacheKey, result);
    return result;
  }

  get priceCents() {
    return (
      this.reservation?.experiencePriceLabels?.find((e) => e.islabel1)?.price_cents ||
      this.experience?.prices.find((x) => x.position == 0 && x.priceType == "LABEL")?.priceCents ||
      0
    );
  }

  get experienceType() {
    return this.experience?.metaDatas?.find((x) => experienceTypeCodes.includes(x.metadataValue))?.metadataValue || "tasting";
  }

  get useEventDatePicker(): boolean {
    return this.experienceType === "event" && this.eventDates.length > 0;
  }

  get experienceLanguages() {
    // If an experience is selected, return its supported languages
    if (this.experience?.metaDatas) {
      return this.experience.metaDatas.filter((x) => x.metadataValue.startsWith("lang_"))?.map((i) => i.metadataValue.split("_")[1]) || [];
    }

    // If no experience is selected, return all available languages as fallback
    // This ensures the language field is always available for new reservations
    return this.languages?.map((lang) => lang.iso) || [];
  }

  get filteredExperiencesComputed(): ExperienceDWS[] {
    if (!this._experienceSearchTerm || this._experienceSearchTerm.trim() === "") {
      return this.availableExperiencesActive;
    }

    const query = this._experienceSearchTerm.toLowerCase();
    return this.availableExperiencesActive?.filter((e) =>
      e.details?.titles?.find((t) =>
        !!t?.text && t.text.toLowerCase().includes(query)
      )
    ) || [];
  }

  get countForExperience(): ExperienceAvailability2 | undefined {
    return this.getCountForExperience();
  }

  get coupon() {
    return this.form.get("reservation")?.get("coupon_code")?.value;
  }

  get isCouponDiscountReadonly(): boolean {
    return !!(
      this.reservation?.couponCode ||
      this.form.get("reservation")?.get("paidAmout")?.value > 0
    );
  }

  get couponPercent(): number | null {
    const coupon = this.availableCoupons.find((c) => c.code === this.coupon);
    if (coupon) return coupon.discount_type === "percent" ? coupon.discount_percent : null;
    return +(this.reservation?.otherData || this.reservation?.optionalData)?.coupon_discount_percent || null;
  }

  get stripeConnected() {
    // Check for ws-payment integration (dwspay) first, then fallback to legacy accept_stripe_payments
    const dwspayEnabled = this.dwspayIntegration &&
                          !this.dwspayIntegration.disabled &&
                          this.dwspayIntegration.connected;
    return dwspayEnabled || this.companyInt?.accept_stripe_payments;
  }

  /** Raw invoice payload from form (no booker-name fallback). */
  private get rawInvoiceData(): Record<string, any> | null {
    try {
      const stored = this.form.value?.reservation?.invoiceData;
      if (!stored) {
        return null;
      }
      const raw = typeof stored === "string" ? JSON.parse(stored) : stored;
      if (!raw || typeof raw !== "object") {
        return null;
      }
      return raw;
    } catch {
      return null;
    }
  }

  get invoiceData() {
    const raw = this.rawInvoiceData;
    if (!raw) {
      return raw;
    }
    // Historical READ fallback: missing intestatario names → booker (do not persist).
    const data = { ...raw };
    if (!data.companyName) {
      const master = this.masterContactControl;
      if (!data.firstName && master?.get("firstName")?.value) {
        data.firstName = master.get("firstName")?.value;
      }
      if (!data.lastName && master?.get("lastName")?.value) {
        data.lastName = master.get("lastName")?.value;
      }
    }
    return data;
  }

  get invoiceKeys() {
    const data = this.invoiceData || {};
    if (!data || Object.keys(this.rawInvoiceData || {}).length === 0) {
      return [];
    }
    const isCompany = !!data.companyName;
    return invoiceKeyNames.filter((x) =>
      isCompany ? !invoicePersonOnlyKeys.includes(x) : !invoiceCompanyOnlyKeys.includes(x)
    );
  }

  /** True when Nome/Cognome intestatario are missing on the record and shown from booker. */
  get isInvoiceIntestatarioNameFallback(): boolean {
    const raw = this.rawInvoiceData;
    if (!raw || raw.companyName) {
      return false;
    }
    const hasStoredNames = !!(raw.firstName || raw.lastName);
    if (hasStoredNames) {
      return false;
    }
    const master = this.masterContactControl;
    return !!(master?.get("firstName")?.value || master?.get("lastName")?.value);
  }

  /** After commercial document / invoice emission, billing block is read-only. */
  get isInvoiceDataReadOnly(): boolean {
    return (
      this.form?.get("reservation")?.get("isSales")?.value === true ||
      this.reservation?.otherData?.isSales === true ||
      this.reservation?.otherData?.isSales === "true"
    );
  }

  invoiceFieldDisplayValue(key: string): string {
    const val = this.invoiceData?.[key];
    if (val == null || val === "") {
      return "-";
    }
    if (typeof val === "object" && (val.nameIt || val.nameEn || val.name || val.iso)) {
      return val.nameIt || val.nameEn || val.name || val.iso || "-";
    }
    return String(val);
  }

  getExperienceName(experience?: ExperienceDWS) {
    if (!experience?.details?.titles || !Array.isArray(experience.details.titles)) return "";

    // Ensure cache is initialized
    if (!this._cachedExperienceName) {
      this._cachedExperienceName = new Map();
    }

    // Create cache key
    const cacheKey = `${experience.id}_${this.lang}`;

    // Return cached result if available
    if (this._cachedExperienceName.has(cacheKey)) {
      return this._cachedExperienceName.get(cacheKey)!;
    }

    const getTitle = (experience: ExperienceDWS): string => {
      const currentLang = normalizeLangIso(this.lang);
      let title = experience.details.titles.find(
        (x) => x?.languageIsoCode != null && normalizeLangIso(String(x.languageIsoCode)) === currentLang
      );
      if (title?.shortLabel || title?.text) return title.shortLabel || title.text || "";
      title = experience.details.titles.find(
        (x) => x?.languageIsoCode != null && normalizeLangIso(String(x.languageIsoCode)) === "en"
      );
      if (title?.shortLabel || title?.text) return title.shortLabel || title.text || "";
      return "";
    };

    const result = getTitle(experience);
    this._cachedExperienceName.set(cacheKey, result);
    return result;
  }

  private mergedPriceCaptionMap(position: number, kind: "LABEL" | "EXTRA", reservationRow: any | undefined): Record<string, string> {
    const expRow = this.findExperiencePriceRow(position, kind);
    return {
      ...langMapFromPriceRow(expRow),
      ...(reservationRow?.title_translations != null ? langMapFromTranslationsBlob(reservationRow.title_translations) : {}),
    };
  }

  private experiencePriceRowMatchesKind(row: any, kind: "LABEL" | "EXTRA"): boolean {
    const pt = row?.priceType ?? row?.price_type;
    if (pt === undefined || pt === null || String(pt).trim() === "") return false;
    return String(pt).trim().toUpperCase() === kind;
  }

  private findExperiencePriceRow(position: number, kind: "LABEL" | "EXTRA"): any {
    return this.experience?.prices?.find((x: any) => Number(x?.position) === Number(position) && this.experiencePriceRowMatchesKind(x, kind));
  }

  /** Account language first for UI copy; **`en`** is the only fallback (always present from the API). */
  getLabelOrExtra(position: number, type: "LABEL" | "EXTRA" = "LABEL", language?: string) {
    const reservationItems =
      type === "LABEL" ? this.reservation?.experiencePriceLabels : this.reservation?.experiencePriceExtras;
    const reservationItem = reservationItems?.find((x) => x.position == position);
    const merged = this.mergedPriceCaptionMap(position, type, reservationItem);
    return captionFromLangMap(merged, priceCaptionPickOrder(this.lang, language));
  }

  /** Reservation + experience first; then form `title_translations` when API side is empty. */
  getPriceRowCaption(row: FormGroup, index: number, kind: "LABEL" | "EXTRA", language?: string): string {
    const pickOrder = priceCaptionPickOrder(this.lang, language);
    const pos = this.getPriceRowPosition(row, index);

    const fromApi = this.getLabelOrExtra(pos, kind, language).trim();
    const formBlob = row.get("title_translations")?.value;
    const fromForm = captionFromLangMap(langMapFromTranslationsBlob(formBlob), pickOrder).trim();
    return fromApi || fromForm;
  }

  /** Avoid `?.` / `??` in templates (parser issues in some Angular versions). */
  getPriceRowPosition(row: FormGroup, index: number): number {
    const ctrl = row.get("position");
    const v = ctrl != null ? ctrl.value : null;
    if (v !== null && v !== undefined && v !== "") {
      const n = Number(v);
      return Number.isNaN(n) ? index : n;
    }
    return index;
  }

  getPriceRowCentsForDisplay(row: FormGroup): number {
    const ctrl = row.get("price_cents");
    const v = ctrl != null ? ctrl.value : 0;
    const n = typeof v === "number" ? v : Number(v);
    return (Number.isFinite(n) ? n : 0) / 100;
  }

  getRoom(roomId: string) {
    return this.rooms.find((room) => room.id == roomId);
  }

  getEmployee(employeeId: string) {
    return this.team.find((employee) => employee.id == employeeId);
  }

  changePaid(event: MatCheckboxChange) {
    this.clearCommercialDocumentPaymentHighlights();
    if (event.checked) {
      if (this.form.get("reservation")?.get("due")?.value) {
        this.temporaryFormValues["due"] = this.form.get("reservation")?.get("due")?.value;
        this.temporaryFormValues["paidAmout"] = this.form.get("reservation")?.get("paidAmout")?.value;
      }

      var paid = this.form.get("reservation")?.get("paidAmout")?.value;
      var due = this.form.get("reservation")?.get("due")?.value;
      var total = (this.form.get("reservation")?.get("total")?.value - (this.form.get("reservation")?.get("giftAmount")?.value ?? 0)) as number;
      this.form.patchValue({
        reservation: {
          paidAmout: total,
          due: 0,
        },
      });
    } else {
      if (this.temporaryFormValues["due"]) {
        this.form.get("reservation")?.get("due")?.setValue(this.temporaryFormValues["due"]);
        this.form.get("reservation")?.get("paidAmout")?.setValue(this.temporaryFormValues["paidAmout"]);
      }
    }
  }

  constructor(
    private fb: FormBuilder,
    private reservationsService: ReservationsService,
    private accountsService: AccountsService,
    private permissionResolver: PermissionResolverService,
    private giftsService: GiftsService,
    private contactsService: ContactsService,
    private dlg: MatDialog,
    private dialogForClone: MatDialog,
    private experienceAvailabilitiesService: ExperienceAvailabilitiesService,
    private availabilityServiceDws: ExperienceAvailabilityService,
    private manualReservationListenerService: ManualReservationRequestsListenerService,
    private reservationFormOptionsService: HostReservationFormOptionsService,
    private reservationDetailService: ReservationDetailService,
    private backgroundService: BackgroundService,
    private availabilityBlockService: AvailabilityBlockService,
    private router: Router,
    private experienceAvailabilityService: ExperienceAvailabilityService,
    private paymentMethodsService: PaymentMethodsService,
    private translate: TranslateService,
    private statisticsService: StatisticsService,
    private contactsTagsService: ContactsTagsService,
    private cd: ChangeDetectorRef,
    private cdr: ChangeDetectorRef,
    private externalCalendarSyncService: ExternalCalendarSyncService,
    private languageService: LanguagesService,
    private dwsLanguagesService: DWSLanguagesService,
    private experienceEventsAvailabilitiesService: ExperienceEventsAvailabilitiesService,
    private reservationContactsService: ReservationContactsService,
    private wsPaymentsService: WSPaymentsService,
    private paymentsPaymentDetailDialogService: PaymentsPaymentDetailDialogService,
    private cashRegisterService: CashRegisterService,
    private hostCouponsService: HostCouponsService,
    private syncHelper: SyncHelperService,
    private dialogForManageEmailSending: MatDialog,
    private wineryIntegrationsService: WineryIntegrationsService,
  ) {
    this.clientForm = this.fb.group({
      firstname: ["", Validators.required],
      lastname: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
      phone: [""],
    });
    this.language = translate.getDefaultLang();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Clear all caches to ensure fresh data when language changes
   */
  private clearCaches(): void {
    this._cachedCountForExperience = undefined;
    this._lastCountCacheKey = "";
    this._cachedExperienceName.clear();
    this._cachedTranslatedName.clear();
  }

  /**
   * Clear count cache when availability data changes
   */
  private clearCountCache(): void {
    this._cachedCountForExperience = undefined;
    this._lastCountCacheKey = "";
  }

  /**
   * Optimized change detection trigger for OnPush strategy
   */
  private triggerChangeDetection(): void {
    this.cdr.markForCheck();
  }

  /**
   * Batch form updates to reduce change detection cycles
   */
  private batchFormUpdates(updates: () => void): void {
    // Disable change detection temporarily
    this.cdr.detach();

    try {
      updates();
    } finally {
      // Re-enable change detection and trigger it once
      this.cdr.reattach();
      this.cdr.markForCheck();
    }
  }

  ngOnInit(): void {
    this.form = this.generateForm();

    fromEvent(document, "visibilitychange")
      .pipe(
        filter(() => document.visibilityState === "visible"),
        debounceTime(400),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        if (this.paymentLinkData) {
          this.refreshReservationPaymentState();
        }
      });

    fromEvent(window, "focus")
      .pipe(debounceTime(400), takeUntil(this.destroy$))
      .subscribe(() => {
        if (this.hasActiveUnpaidPaymentLink()) {
          this.refreshReservationPaymentState();
        }
      });

    // Set CSS custom properties for translatable text in CSS
    this.setTranslatableCSSProperties();

    // Listen for language changes and update CSS custom properties
    this.translate.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.setTranslatableCSSProperties();
      this.clearCaches();
    });

    this.accountsService.company$
      .pipe(
        filter((x) => x != null),
        takeUntil(this.destroy$)
      )
      .subscribe((x) => {
        this.companyInt = x!;
        this.companyId$.next(x!.id);
        this.companyId = x!.id;

        // Load dwspay integration if company is available
        if (x!.id) {
          this.wineryIntegrationsService.getWineryIntegration(x!.id, 'dwspay')
            .pipe(
              takeUntil(this.destroy$),
              catchError(() => of(undefined))
            )
            .subscribe((integration) => {
              this.dwspayIntegration = integration;
              this.cdr.markForCheck();
            });
        }

        if (this.reservationId) {
          console.log("🚀 [TIMING] Starting reservation detail loading for ID:", this.reservationId);
          const startTime = performance.now();

          // Show loading immediately for MUST calls (no 200ms delay)
          this.loading = true;

          // MUST calls - run in parallel for faster loading
          this.reservationDetailService.getV2(this.reservationId).pipe(
            tap(() => console.log("📡 [TIMING] getV2 call started")),
            takeUntil(this.destroy$),
            switchMap((r) => {
              const reservationLoadTime = performance.now() - startTime;
              console.log(`✅ [TIMING] getV2 completed in ${reservationLoadTime.toFixed(2)}ms`);
              console.log(
                "Form-options service call (with experienceId) - Current experience:",
                this.experience
              );

              const parallelStartTime = performance.now();
              return forkJoin([
                // MUST calls - required for basic functionality
                this.languageService.list().pipe(
                  tap(() => console.log("📡 [TIMING] languageService.list() started")),
                  tap(() => console.log("✅ [TIMING] languageService.list() completed"))
                ),
                this.reservationFormOptionsService.get(
                  this.companyId,
                  r.experienceId!
                ).pipe(
                  tap(() => console.log("📡 [TIMING] reservationFormOptionsService.get() started")),
                  tap(() => console.log("✅ [TIMING] reservationFormOptionsService.get() completed"))
                ),
              ]).pipe(
                tap(() => {
                  const parallelLoadTime = performance.now() - parallelStartTime;
                  this.loading = false;
                  this.mustCallsLoaded = true;
                  console.log(`✅ [TIMING] Parallel MUST calls completed in ${parallelLoadTime.toFixed(2)}ms`);
                }),
                map(([languages, opts]) => ({
                  reservation: r,
                  languages: languages.content,
                  opts: opts,
                }))
              );
            })
          ).subscribe(
            ({ reservation, languages, opts }) => {
              const totalLoadTime = performance.now() - startTime;
              console.log(`🎉 [TIMING] All MUST calls completed in ${totalLoadTime.toFixed(2)}ms`);
              console.log(
                "Form-options data received (with experienceId):",
                opts
              );

              // SET LANGS
              this.languages = languages;
              reservation.language = this.languages.find(
                (e) => e.iso == reservation.languageIso
              );
              // SET RESERVATION IF ANY
              this.reservation = reservation;

                const isTourOperator = reservation.otherData?.isTourOperator;
                if (isTourOperator) {
                  this.isTourOperator = isTourOperator;
                }

              this.manageOpt(opts);

              // Update form control states after options are loaded
              this.updateFormControlStates();

              // Trigger change detection for OnPush strategy
              this.cdr.markForCheck();

                // TODO GET activatedExperienceAutomations and use them, now is always CLOSE
                this.isDraftable = this.reservation?.state == "draft" || false;
                if (!this.isDraftable) {
                  const isCloseMatchingSlotLanguagesInTheSameExperienceActive =
                    opts.activatedExperienceAutomations.indexOf("CLOSE_MATCHING_SLOT_LANGUAGES_IN_THE_SAME_EXPERIENCE") > -1;
                  const isCloseMatchingSlotInOtherExperiencesActive =
                    opts.activatedExperienceAutomations.indexOf("CLOSE_MATCHING_SLOTS_IN_OTHER_EXPERIENCES") > -1;
                  const slotClosingPopupShouldNotAppear = isCloseMatchingSlotLanguagesInTheSameExperienceActive && isCloseMatchingSlotInOtherExperiencesActive;
                  this.shouldAskForSlotClosing = !slotClosingPopupShouldNotAppear;
                } else {
                  this.shouldAskForSlotClosing = false;
                }

                // Set basic form values without API calls
                this.setBasicFormValues();

                this.onInitMc();

                this.checkIfPaymentFailed(reservation);

                // OPTIONAL calls - run after MUST calls are completely done to avoid server overload
                this.scheduleOptionalDataLoading(reservation);
                this.finalizeInitialDwspayPaymentUiLoading();
                this.checkPaymentRefunded();
              },
              (error) => {
                console.error("Error loading reservation detail:", error);
                this.mustCallsLoaded = true;
                this.dwspayPaymentUiTracking = false;
                this.syncDwspayPaymentUiLoading();
              }
            );
        } else {
          this.isDraftable = true;

          console.log("🚀 [TIMING] Starting new reservation loading (no reservationId)");
          const newReservationStartTime = performance.now();

          // Show loading immediately for MUST calls (no 200ms delay)
          this.loading = true;

          console.log(
            "Form-options service call (without experienceId) - Current experience:",
            this.experience
          );
          // MUST calls - run in parallel for faster loading
          forkJoin([
            this.languageService.list().pipe(
              tap(() => console.log("📡 [TIMING] languageService.list() started (new reservation)")),
              tap(() => console.log("✅ [TIMING] languageService.list() completed (new reservation)"))
            ),
            this.reservationFormOptionsService.get(this.companyId, "").pipe(
              tap(() => console.log("📡 [TIMING] reservationFormOptionsService.get() started (new reservation)")),
              tap(() => console.log("✅ [TIMING] reservationFormOptionsService.get() completed (new reservation)"))
            ),
          ])
            .pipe(
              takeUntil(this.destroy$),
              tap(() => {
                const newReservationLoadTime = performance.now() - newReservationStartTime;
                console.log(`✅ [TIMING] New reservation MUST calls completed in ${newReservationLoadTime.toFixed(2)}ms`);
              })
            )
            .subscribe(
              ([languages, opts]) => {
                console.log("Form-options data received (without experienceId):", opts);
                this.languages = languages.content;

                this.shouldAskForSlotClosing = false;

            this.manageOpt(opts);

            // Update form control states after options are loaded
            this.updateFormControlStates();

            // Set basic form values without API calls
            this.setBasicFormValues();
            this.onInitMc();

                // OPTIONAL calls - run after MUST calls are completely done to avoid server overload
                this.scheduleOptionalDataLoadingForNewReservation();
                this.mustCallsLoaded = true;
                this.syncDwspayPaymentUiLoading();
              },
              (error) => {
                console.error("Error loading new reservation data:", error);
                this.mustCallsLoaded = true;
                this.dwspayPaymentUiTracking = false;
                this.syncDwspayPaymentUiLoading();
              }
            );
        }
      });
  }

  manageOpt(opts: DWSFormOptions) {
    console.log("Form-options called - Current experience:", this.experience);
    this.availableVisitReasons = opts.visitReasons;
    this.availableExperiences = opts.experiences;

    this.experience = this.getExperienceOrDefault();
    this.manualOrigins = this.isTourOperator ? opts.manualOrigins : opts.manualOrigins.filter((x) => x.id !== 5);
    this.paymentMethods = opts.paymentMethods;
    this.availabilitiesBlock = opts.availabilityBlocks;
    this.hasEnabledAutomations = opts.activatedExperienceAutomations.length > 0;
    const rooms = opts.rooms;
    this.rooms$.next(rooms);

    const employees = opts.employees;

    this.employees$.next(employees);
    this.countries = opts.countries;

    this.availableExperiencesActive = opts.experiences
      .filter((r) => r.details.active === true)
      .sort((a, b) => {
        if (a.details.priority === null && b.details.priority === null) {
          // Helper function to get experience title with fallback
          const getExperienceTitle = (experience: any): string => {
            if (!experience?.details?.titles || !Array.isArray(experience.details.titles)) {
              return "";
            }

            const currentLang = this.lang || "en"; // Ensure we have a language

            // Try current language first
            let title = experience.details.titles.find((x: any) => x?.languageIsoCode?.toLowerCase() === currentLang.toLowerCase());
            if (title?.text) return title.text;

            // Fallback to English
            title = experience.details.titles.find((x: any) => x?.languageIsoCode?.toLowerCase() === "en");
            if (title?.text) return title.text;

            // Fallback to Italian
            title = experience.details.titles.find((x: any) => x?.languageIsoCode?.toLowerCase() === "it");
            if (title?.text) return title.text;

            // Fallback to first available title
            return experience.details.titles[0]?.text || "";
          };

          const titleA = getExperienceTitle(a);
          const titleB = getExperienceTitle(b);

          return titleA > titleB ? 1 : -1;
        } else if (a.details.priority === null) {
          return 1;
        } else if (b.details.priority === null) {
          return -1;
        } else {
          return a.details.priority! > b.details.priority! ? 1 : -1;
        }
      });

    this.filteredExperiences = this.availableExperiencesActive;
  }

  onInitMc() {
    this.listenerForFetchAvailability();

    this.rooms$.pipe(takeUntil(this.destroy$)).subscribe((rooms) => {
      this.rooms = rooms;
      this.patchFormRoom();
    });

    this.employees$.pipe(takeUntil(this.destroy$)).subscribe((employees) => {
      this.team = employees;
      this.patchFormEmployee();
    });

    // 200ms debounce; API only when trimmed query has at least clientSearchMinChars (hint in panel otherwise).
    let pipeSearchControl = (control: FormControl, isMasterContactControl: boolean) => {
      return control.valueChanges.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        filter((v): v is string => typeof v === "string"),
        filter(() => !!this.companyId),
        switchMap((v: string) => {
          const trimmed = v.trim();
          if (trimmed.length < this.clientSearchMinChars) {
            return of({ content: [] } as unknown as Page<Contact>).pipe(
              tap(() => {
                this.clients = [];
                this.loadingClients = false;
                this.cdr.markForCheck();
              })
            );
          }
          this.clients = [];
          this.loadingClients = true;
          this.cdr.markForCheck();
          return this.contactsService
            .list({
              q: trimmed,
              wineryIds: [this.companyId],
              includeUnsubscribed: false,
              includeSubscribed: false,
              tourOperators: this.isTourOperator && isMasterContactControl,
            })
            .pipe(
              finalize(() => {
                this.loadingClients = false;
                this.cdr.markForCheck();
              })
            );
        })
      );
    };

    this.masterClients$ = pipeSearchControl(this.masterSearchControl, true);
    this.clients$ = pipeSearchControl(this.searchControl, false);

    let f = (c: Page<Contact>) => {
      this.clients = c.content.filter((c) => c.email != null);
      this.loadingClients = false;
      this.cdr.markForCheck();
    };
    this.masterClients$.pipe(takeUntil(this.destroy$)).subscribe(f);
    this.clients$.pipe(takeUntil(this.destroy$)).subscribe(f);

    const r = this.form.get("reservation")!;
    if (this.canEdit) {
      if (!this.reservationToClone) {
        r.get("date")!
          .valueChanges.pipe(debounceTime(300), takeUntil(this.destroy$))
          .subscribe((v: any) => {
            if (this.experience?.id) {
              this.updateAvailabilitiesList(this.experience?.id!, v);
            }
          });
      }
    }
    if (this.reservationToClone) {
      //language & experience disabled with html
      // Disabilita i campi date e time solo se NON è una nuova prenotazione dal calendario
      if (!this.isNewReservationFromCalendar) {
        r.get("time")!.disable();
        r.get("date")!.disable();
        if (!!!!r.get("event-date")!) {
          r.get("event-date")!.disable();
        }
      }
    } else {
      r.patchValue({
        paymentMethod: "winery",
      });
      r.get("lang")!.disable();

      r.get("time")!
        .valueChanges.pipe(debounceTime(300), takeUntil(this.destroy$))
        .subscribe((time) => {
          if (!!time) {
            const date = moment(r.get("date")!.value as Moment);
            const hours = time.split(":")[0];
            const minutes = time.split(":")[1];
            date.add(minutes, "minutes").add(hours, "hours");
            if (date.isBefore(moment().add(-24, "hours"))) r.get("notify_contact")?.setValue(false);
          }

          // this.availableLanguages = this.experience.
          r.get("lang")!.enable();
        });
    }

    if (this.reservation?.state === "confirmed" && !(this.reservation.type === "manual")) {
      this.isConfirmedReservation = true;
    }

    if (
      this.reservation?.state == "revoked" ||
      this.reservation?.state == "canceled" ||
      this.reservation?.state == "rejected" ||
      this.reservation?.state == "deleted"
    ) {
      observe(this.reservationDetailService.getReservationHistory(this.reservation.id!, "edit_gift")).subscribe((history) => {
        if (history.length > 0) {
          this.giftAssociatedBeforeRevocation = history[0].externalEntityPk;
        }
      });
    }

    if (this.reservation) {
      this.getUpdatedAvailabilities(this.reservation.date!, this.reservation.time!, this.reservation.experienceId!);
    }
  }

  onClientSearchFocus(isMasterContactControl: boolean) {
    const control = isMasterContactControl ? this.masterSearchControl : this.searchControl;
    const currentValue = typeof control.value === "string" ? control.value.trim() : "";
    if (currentValue.length >= this.clientSearchMinChars) {
      return;
    }
    this.clients = [];
    this.loadingClients = false;
    this.cdr.markForCheck();
  }

  /** True when the string query is shorter than clientSearchMinChars (show hint in autocomplete). */
  clientSearchShowsMinCharsHint(control: FormControl): boolean {
    const v = control.value;
    if (v != null && typeof v === "object") {
      return false;
    }
    const s = typeof v === "string" ? v : "";
    return s.trim().length < this.clientSearchMinChars;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["reservation"]) {
      const reservationChanges = changes["reservation"];
      if (
        reservationChanges.currentValue &&
        !reservationChanges.isFirstChange()
      ) {
        this.checkPaymentRefunded();
        this.markCalculatedFieldsAsPristine();
        if (this.form.pristine && this.clientForm.pristine) {
          this.setFormValues();
        }
      }
    }

    if (changes["reservationToClone"]) {
      const reservationToCloneChanges = changes["reservationToClone"];
      if (
        reservationToCloneChanges.currentValue &&
        !reservationToCloneChanges.isFirstChange()
      ) {
        this.markCalculatedFieldsAsPristine();
        if (this.form.pristine && this.clientForm.pristine) {
          this.setFormValues();
        }
      }
    }
  }

  checkIfPaymentFailed(reservation: any): void {
    if (reservation?.state == "waiting" && (reservation?.otherData?.paymentFailed === true || reservation?.otherData?.paymentFailed === "true")) {
      this.dlg.open(FailedPaymentComponent, {
        data: {
          isWarning: false,
          isAction: true,
          text: tr("Attention!"),
          actionText: tr("Payment confirmation"),
          items: [tr("This reservation hasn't been confirmed because the payment failed. Please check the payment status and try again.")],
          callback: async () => {
            const mex = tr(
              "The payment for this reservation has been marked as failed, but it may have been successfully received. Are you sure you want to manually confirm the reservation and unlock it?"
            );

            const sure = await confirm.yesno(mex, tr("Confirm!"), tr("Cancel"));
            if (!sure) return;

            var reservationId = this.reservationId!;

            this.isSaving(true);

            this.manualReservationListenerService.addRequestIdToListener(reservationId, reservationId, this.reservation!.state!);

            // forcePayment=true → CRM calls Ruby with force_payment (close order, confirm without capture)
            this.reservationDetailService
              .confirmReservationAndForcePaymentV2(reservationId, true)
              .pipe(finalize(() => this.isSaving(false)))
              .subscribe({
                next: () => this.closeClick.emit(),
                error: (err) => toast(tr(err)),
              });
          },
        },
        minWidth: 550,
        maxWidth: 550,
      });
    }
  }

  getUpdatedAvailabilities(date: string, time: string, experienceId: string) {
    const wineryId = this.companyId;
    if (date && time && experienceId) {
      var dayStart = moment(date).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate();
      var dayEnd = moment(date).set({ hour: 23, minute: 59, second: 59, millisecond: 0 }).add(1, "day").toDate();
      this.availabilityServiceDws.getAvailabilities(wineryId, dayStart, dayEnd).subscribe((data) => {
        var experienceAva = data.filter((x) => x.experience.id === experienceId);
        this.availabilities2 = experienceAva;
      });
    }
  }

  canEditPartecipants(): boolean {
    return this.canEditField("partecipants") && ((this.reservation && !this.confirmed && !this.waiting) || (this.canEdit && this.experience !== null) || false);
  }

  getCountForExperience(): ExperienceAvailability2 | undefined {
    const time =
      this.reservation?.time ||
      this.form.get("reservation")?.get("time")?.value;
    const date =
      this.reservation?.date ||
      this.form.get("reservation")?.get("date")?.value;

    // Create cache key
    const cacheKey = `${date}_${time}`;

    // Return cached result if available and key matches
    if (this._cachedCountForExperience && this._lastCountCacheKey === cacheKey) {
      return this._cachedCountForExperience;
    }

    // Find and cache result
    const founded = this.availabilities2.find(
      (x) => x.day === date && x.time === time
    );

    this._cachedCountForExperience = founded;
    this._lastCountCacheKey = cacheKey;

    return founded;
  }

  fillPriceLabels() {
    const control = this.experiencePriceLabelsFormArray;
    control.clear();

    const labels = (this.experience?.prices ?? []).filter((p) => p.priceType === "LABEL");
    const experiencePositions = new Set(labels.map((l) => l.position));

    for (const pl of labels.sort((a: { position: number }, b: { position: number }) => a.position - b.position)) {
      control.push(ExperiencePriceLabel.createFormGroup(this.fb, pl, this.lang));
    }

    if (this.reservation?.experiencePriceLabels?.length) {
      const reservationLabels = this.reservation.experiencePriceLabels;
      const additionalLabels = reservationLabels.filter((rl) => !experiencePositions.has(rl.position));
      for (const rl of additionalLabels.sort((a, b) => a.position - b.position)) {
        control.push(ExperiencePriceLabel.createFormGroup(this.fb, rl, this.lang));
      }

      this.patchFormPriceLabels(this.reservation);
    }
  }

  fillPriceExtras() {
    const control = this.experiencePriceExtrasFormArray;
    control.clear();

    const extras = (this.experience?.prices ?? []).filter((p) => p.priceType === "EXTRA");
    const experiencePositions = new Set(extras.map((e) => e.position));

    for (const pe of extras.sort((a: any, b: any) => a.position - b.position)) {
      control.push(ExperiencePriceExtra.createFormGroup(this.fb, pe, this.lang));
    }

    if (this.reservation?.experiencePriceExtras?.length) {
      const reservationExtras = this.reservation.experiencePriceExtras;
      const additionalExtras = reservationExtras.filter((re) => !experiencePositions.has(re.position));
      for (const re of additionalExtras.sort((a, b) => a.position - b.position)) {
        control.push(ExperiencePriceExtra.createFormGroup(this.fb, re, this.lang));
      }

      this.patchFormPriceExtras(this.reservation);
    }
  }

  private patchFormPriceLabels(r: ReservationDTO) {
    let priceLabels = [...r.experiencePriceLabels!];
    if (!priceLabels.find((x) => x.islabel1 == true) && priceLabels.find((x) => x.position == 0)) {
      priceLabels.forEach((x) => (x.position += 1));
    }
    priceLabels = priceLabels.filter((x) => !x.islabel1);
    const controls = this.formArrayPriceLabels;
    for (const c of controls) {
      const pos = Number(c.get("position")?.value);
      const resRow = r.experiencePriceLabels?.find((x) => x.position == pos);
      const captionSlots = fillTitleSlotsFromMergedMap(this.mergedPriceCaptionMap(pos, "LABEL", resRow), this.lang);

      if (c.get("position")?.value == 0) {
        const label1 = r.experiencePriceLabels?.find((x) => x.islabel1);
        c.patchValue({
          quantity: label1?.quantity ?? r.guestCount01 ?? 0,
          price_cents: label1?.price_cents ?? (this.priceCents || 0),
          islabel1: true,
          title_translations: captionSlots,
        });
      } else {
        const pl: any = priceLabels.find((x) => x.position == c.get("position")?.value) || {};
        c.patchValue({
          quantity: pl.quantity || 0,
          title_translations: captionSlots,
        });
        if (pl.price_cents !== null && pl.price_cents !== undefined) {
          c.patchValue({
            price_cents: pl.price_cents,
          });
        }
      }
    }
  }

  private patchFormPriceExtras(r: ReservationDTO) {
    let priceExtras = [...r.experiencePriceExtras!];
    const controls = this.experiencePriceExtrasFormArray.controls;
    for (const c of controls) {
      const pos = Number(c.get("position")?.value);
      const pe: any = priceExtras.find((x) => x.position == c.get("position")?.value) || {};
      const resRow = r.experiencePriceExtras?.find((x) => x.position == pos);
      const captionSlots = fillTitleSlotsFromMergedMap(this.mergedPriceCaptionMap(pos, "EXTRA", resRow), this.lang);
      c.patchValue({
        quantity: pe.quantity || 0,
        title_translations: captionSlots,
      });
      if (pe.price_cents !== null && pe.price_cents !== undefined) {
        c.patchValue({
          price_cents: pe.price_cents,
        });
      }
    }
  }

  getGuestCount(n: number) {
    return this.reservation?.experiencePriceLabels?.find((e) => e.position === n)?.quantity || 0;
  }

  dateAvailableFilter = (d: Moment) => {
    if (!this.experience) return false;
    if (this.reservation && isSameDay(d.toDate(), parse(this.reservation!.date!, "yyyy-MM-dd", new Date()))) {
      return true;
    }
    return ExperienceAvailability.isDayAvailable(this.availabilities, d.toDate());
  };

  openGiftDialog() {
    if (this.reservation?.giftId || this.giftAssociatedBeforeRevocation) {
      observe(this.gift ? of(this.gift) : this.giftsService.getGiftById((this.reservation?.giftId || this.giftAssociatedBeforeRevocation)!)).subscribe(
        (gift) => {
          this.gift = gift;
          const dlg = this.dlg.open(GiftDetailComponent, {
            width: "50%",
            minWidth: 1000,
            maxWidth: 1000,
            data: {
              gift,
              returnToReservation: true,
            },
          });
          dlg.afterClosed().subscribe((res) => {});
        },
        (error) => {
          if (error.status === 404) {
            toast(tr("Cannot find this gift."));
            console.log(error);
          } else toast(tr(this.messageError));
        }
      );
    }
  }

  compareStatus = (a: MappedStatus, b: MappedStatus) => {
    return a.type === b.type;
  };

  get orderCountries(): HostReservationFormOptions.Country[] {
    return this.countries.sort((a, b) => {
      return this.language === "en" ? a.nameEn!.localeCompare(b.nameEn || "") : a.nameIt!.localeCompare(b.nameIt || "");
    });
  }

  getOrderCountryByIso(iso: string): HostReservationFormOptions.Country | undefined {
    return this.orderCountries.find((c) => c.iso === iso);
  }

  private extractDateString = (date: any) => {
    if (moment.isMoment(date)) return (date as Moment).format("YYYY-MM-DD");
    else if (date instanceof Date) return format(date, "yyyy-MM-dd");
    else if (moment(date, "YYYY-MM-DD").isValid()) return moment(date, "YYYY-MM-DD").format("YYYY-MM-DD");
    return date as string;
  };

  private getExperienceOrDefault(): ExperienceDWS | undefined {
    return this.availableExperiences.find(
      (e) =>
        this.reservation?.experienceId == e?.id ||
        this.reservation?.experience?.experienceId == e?.id ||
        this.reservationToClone?.experienceId == e?.id ||
        this.reservationToClone?.experience?.experienceId == e?.id
    );
  }

  patchFormRoom() {
    this.batchFormUpdates(() => {
      const reservationRoom = this.form.get("reservation")!.get("room");
      if (this.reservation?.roomId) {
        reservationRoom!.enable();
        reservationRoom!.setValue(this.getRoom(this.reservation.roomId));
      }
      if (this.reservationToClone?.roomId) {
        reservationRoom!.enable();
        reservationRoom!.setValue(this.getRoom(this.reservationToClone.roomId));
      }
    });
  }

  patchFormEmployee() {
    this.batchFormUpdates(() => {
      const reservationEmployee = this.form.get("reservation")!.get("employee");
      if (this.reservation?.employeeId) {
        reservationEmployee!.enable();
        reservationEmployee!.setValue(this.getEmployee(this.reservation.employeeId));
      }
      if (this.reservationToClone?.employeeId) {
        reservationEmployee!.enable();
        reservationEmployee!.setValue(this.getEmployee(this.reservationToClone.employeeId));
      }
    });
  }

  setDateAndTimeForm() {
    const eventDate = this.form.get("reservation")!.get("event_date")?.value;
    if (eventDate) {
      const date = moment(eventDate).format("YYYY-MM-DD");
      const time = moment(eventDate).format("HH:mm");
      if (this.experienceType == "event") {
        this.form.patchValue({
          reservation: {
            date: date,
            time: time,
          },
        });
      }
    }
  }

  setReservationStatusClicked(status: "waiting" | "confirmed" | "rejected") {
    this.editable.state = status;
    this.form.patchValue({
      reservation: {
        status: ReservationDetail.status(undefined, status),
      },
    });
  }

  statusObjectFor(status: "draft" | "waiting" | "confirmed" | "rejected" | "completed" | "canceled" | "revoked") {
    return ReservationDetail.status(undefined, status);
  }

  async cancelClicked() {
    this.markCalculatedFieldsAsPristine();
    if (this.form.pristine && this.clientForm.pristine) return this.closeClick.emit();
    const r = await confirm.yesno(tr("By leaving now you will lose all the changes made to the reservation."), tr("Leave"), tr("Back"));
    if (r) this.closeClick.emit();
  }

  private markCalculatedFieldsAsPristine(): void {
    const calculatedFields = [
      "reservation.total",
      "reservation.additional_discount",
      "reservation.due",
      "reservation.paidAmout",
      "reservation.total_calculated",
    ];

    calculatedFields.forEach((fieldPath) => {
      const control = this.form.get(fieldPath);
      if (control && !control.touched) {
        control.markAsPristine();
      }
    });
  }

  async cloneReservationClicked() {
    if (this.form.pristine && this.clientForm.pristine) {
      this.closeClick.emit();
    } else {
      const r = await confirm.yesno(tr("By leaving now you will lose all the changes made to the reservation."), tr("Leave"), tr("Back"));
      if (r) this.closeClick.emit();
    }
    this.dialogForClone.open(ReservationComponent, {
      data: {
        reservationToClone: this.reservation,
        experience: this.experience,
        isTourOperator: this.isTourOperator,
      },
      width: "98vw",
      maxWidth: "1150px",
    });
  }

  get externalCalendarSync$() {
    return this.externalCalendarSyncService.sync(this.reservation?.id!);
  }

  get isExperienceFieldDisabled(): boolean {
    // Disabilita il campo esperienza solo se è un vero clone (con experienceId) e non una nuova prenotazione dal calendario
    return !!(this.reservationToClone?.experienceId && !this.isNewReservationFromCalendar);
  }

  get isLanguageFieldDisabled(): boolean {
    // Disabilita il campo lingua solo se è un vero clone (con languageIso) e non una nuova prenotazione dal calendario
    return !!(this.reservationToClone?.languageIso && !this.isNewReservationFromCalendar);
  }

  getSlotsPrincipalMessage(mode: "slots" | "languages" | "multiple", actions: string[] = []) {
    if (mode === "slots") {
      if (this.isAvailabilityBlock) {
        return tr("Do you want to open the availability of the other experiences at the same time?");
      } else {
        return tr("Do you want to close the availability of the other experiences at the same time?");
      }
    } else if (mode === "languages") {
      if (this.isLanguageBlock) {
        return tr("Do you want to enable other languages for this slot?");
      } else {
        return tr("Do you want to disable other languages for this slot?");
      }
    } else {
      return tr("Do you want to execute the following actions? ") + actions.map((a) => tr(a)).join(", ");
    }
  }

  getConfirmedButtonMessageOpenSlots(mode: "slots" | "languages") {
    if (mode === "slots") {
      if (!this.isAvailabilityBlock) {
        return tr("Close Slot");
      } else {
        return tr("Open Slot");
      }
    } else {
      if (!this.isLanguageBlock) {
        return tr("Disable Languages");
      } else {
        return tr("Enable Languages");
      }
    }
  }

  getConfirmedButtonMessageCloseSlots(mode: "slots" | "languages") {
    if (mode === "slots") {
      if (this.isAvailabilityBlock) {
        return tr("Keep Closed");
      } else {
        return tr("Keep Open");
      }
    } else {
      if (this.isLanguageBlock) {
        return tr("Keep Disabled");
      } else {
        return tr("Keep Enabled");
      }
    }
  }

  async clickedOpenSlots(skipConfirmation = false) {
    const shouldChangeStateSlots =
      skipConfirmation ||
      (await confirm.yesno(
        this.getSlotsPrincipalMessage("slots"),
        this.getConfirmedButtonMessageOpenSlots("slots"),
        this.getConfirmedButtonMessageCloseSlots("slots")
      ));
    if (!shouldChangeStateSlots) return of(null);

    if (this.isAvailabilityBlock) {
      return await this.openAvailabilities("slots", skipConfirmation);
    }
    return of(null);
  }

  async clickedCloseSlots(skipConfirmation = false) {
    const shouldChangeStateSlots =
      skipConfirmation ||
      (await confirm.yesno(
        this.getSlotsPrincipalMessage("slots"),
        this.getConfirmedButtonMessageOpenSlots("slots"),
        this.getConfirmedButtonMessageCloseSlots("slots")
      ));
    if (!shouldChangeStateSlots) return of(null);

    this.setDateAndTimeForm();
    if (!this.isAvailabilityBlock) {
      return await this.closeAvailabilities("slots", skipConfirmation);
    }
    return of(null);
  }

  async openAvailabilities(mode: "slots" | "languages", isMultipleSelection: boolean): Promise<Observable<any>> {
    if ((mode == "slots" && !this.isAvailabilityBlock) || (mode == "languages" && !this.isLanguageBlock)) return of(null);
    const obs = this.availabilityBlockService.remove(mode === "slots" ? this.isAvailabilityBlock?.id! : this.isLanguageBlock?.id!);
    observe(obs).subscribe(
      () => {
        if (mode === "slots") {
          const date = new Date(this.reservation!.date!);
          this.experienceAvailabilityService
            .getAvailabilities(this.reservation!.wineryId!, date, date)
            .pipe(
              map((availabilities) =>
                availabilities.filter(
                  (a) => a.time === this.reservation?.time && a.active && a.experience.id !== this.reservation?.experienceId && !a.isSingleSlot
                )
              )
            )
            .subscribe(
              (availabilities) => {
                this.dlg
                  .open(NoticeComponent, {
                    minWidth: 550,
                    maxWidth: 550,
                    panelClass: "no-overflow",
                    data: !!availabilities?.length
                      ? {
                          isWarning: false,
                          text: tr("The following slots have been opened:"),
                          items: availabilities.map((uv) => `${uv.experience.title} ${moment(uv.time, "HH:mm:ss").format("HH:mm")}`),
                        }
                      : {
                          isWarning: false,
                          text: tr("There are no slots to open"),
                          items: [],
                        },
                  })
                  .afterClosed()
                  .subscribe(() => {
                    this.closeClick.emit();
                    this.reservationsService.updated$.next();
                  });
              },
              () => toast(tr("All slots have been opened with success"))
            );
        } else {
          this.dlg
            .open(NoticeComponent, {
              minWidth: 550,
              maxWidth: 550,
              panelClass: "no-overflow",
              data: {
                isWarning: false,
                text: tr("Active languages for this slot:"),
                items: this.experienceLanguages.map((l) => tr("lang_" + l)),
              },
            })
            .afterClosed()
            .subscribe(() => {
              this.closeClick.emit();
              this.reservationsService.updated$.next();
            });
        }
      },
      () => toast(tr(this.messageError))
    );

    return obs;
  }

  async closeAvailabilities(mode: "slots" | "languages", isMultipleSelection: boolean): Promise<Observable<any>> {
    const wineryId = this.reservation?.wineryId;
    const date = this.reservation?.date;
    const time = this.reservation?.time;
    const experienceId = this.reservation?.experienceId;
    const languageIso = this.reservation?.languageIso;

    const availabilityBlock = {
      wineryId,
      date,
      time,
      experienceId,
      languageIso,
      disableSlots: mode === "slots",
      disableLanguages: mode === "languages",
    } as AvailabilityBlock;

    const obs = this.availabilityBlockService.create(availabilityBlock).pipe(share());

    observe(obs).subscribe(
      (unclosedAvailabilities) => {
        if (mode === "slots") {
          if (unclosedAvailabilities.length > 0) {
            const dialog = this.dlg.open(NoticeComponent, {
              minWidth: 550,
              maxWidth: 550,
              panelClass: "no-overflow",
              data: {
                isWarning: true,
                text: tr("All slots have been closed except:"),
                items: unclosedAvailabilities.map(
                  (uv) => `${TranslateDomainPipe.transform(uv, "experienceName", "pascal")} at ${moment(uv.experienceTime, "HH:mm:ss").format("HH:mm")}`
                ),
              },
            });
            dialog.afterClosed().subscribe(() => {
              this.closeClick.emit();
              this.reservationsService.updated$.next();
            });
          } else {
            this.dlg
              .open(NoticeComponent, {
                minWidth: 550,
                maxWidth: 550,
                panelClass: "no-overflow",
                data: {
                  isWarning: false,
                  text: tr("All slots have been closed with success"),
                  items: [],
                },
              })
              .afterClosed()
              .subscribe(() => {
                this.closeClick.emit();
                this.reservationsService.updated$.next();
              });
          }
        } else {
          this.dlg
            .open(NoticeComponent, {
              minWidth: 550,
              maxWidth: 550,
              panelClass: "no-overflow",
              data:
                this.experienceLanguages?.length > 1
                  ? {
                      isWarning: false,
                      text: tr("Languages deactivated for this slot:"),
                      items: this.experienceLanguages.filter((l) => l !== languageIso).map((l) => tr("lang_" + l)),
                    }
                  : {
                      isWarning: false,
                      text: tr("There are no other languages to deactivate"),
                      items: [],
                    },
            })
            .afterClosed()
            .subscribe(() => {
              this.closeClick.emit();
              this.reservationsService.updated$.next();
            });
        }
      },
      (e) => {
        if (e && e.error && e.error.status === 400) {
          const confirmed = confirm.yes(tr(e.error.message));
          if (!confirmed) return;
        } else {
          toast(tr(this.messageError));
        }
      }
    );

    return obs;
  }

  getPrincipalMessage(currentState: string | undefined, selectedState: string) {
    if (this.isManualReservation) {
      if (this.hasAnyAvailabilityForDateDay) {
        return this.getBlockMessage();
      }
    }
    if (currentState === "waiting" && selectedState === "confirmed" && this.shouldAskForSlotClosing) {
      return this.getBlockMessage();
    }
    return tr("Are you sure you want to save the changes?");
  }

  private getBlockMessage() {
    if (!this.isAvailabilityBlock) {
      return tr("Do you want to close the availability of the other experiences at the same time?");
    } else {
      return tr("Do you want to open the availability of the other experiences at the same time?");
    }
  }

  getConfirmedButtonMessage(currentState: string | undefined, selectedState: string) {
    if (this.isManualReservation) {
      if (this.hasAnyAvailabilityForDateDay) {
        return this.getConfirmedBlockButton();
      }
    } else if (currentState === "waiting" && selectedState === "confirmed") {
      return this.getConfirmedBlockButton();
    }
    return tr("Save");
  }

  private getConfirmedBlockButton() {
    if (!this.isAvailabilityBlock) {
      return tr("Close Slot");
    } else {
      return tr("Open Slot");
    }
  }

  private getIgnoreBlockButton() {
    if (!this.isAvailabilityBlock) {
      return tr("Keep Open");
    } else {
      return tr("Keep Closed");
    }
  }

  /****************************** */

  /** SAVE RESERVSATION NEW LOGIC */

  async saveDraftClicked() {
    this.isDraft = true;
    await this.doSave();
  }

  async saveClicked() {
    this.isDraft = false;
    await this.doSave();
  }

  async doSave() {
    const reservation = this.reservation;
    const selectedState = this.form.value.reservation.status.type;
    const currentState = reservation?.state;

    var isValidated = this.validateReservationData();
    if (!isValidated) return;

    this.saveDisabled = true;

    // this logic is verifying change state 'waiting' for 'confirmed' or in creation manual reservation (is true) and has any availability for date/hour
    const canUpdateAvailabilities =
      (currentState === "waiting" && selectedState === "confirmed") || (this.isManualReservation && this.hasAnyAvailabilityForDateDay);

    let openSlots = false,
      closeSlots = false;

    // if (this.shouldAskForSlotClosing) {
    //   const shouldContinue = await confirm.yesno(
    //     this.getPrincipalMessage(currentState, selectedState),
    //     this.getConfirmedButtonMessage(currentState, selectedState),
    //     this.getBackButtonMessage(currentState, selectedState)
    //   );

    //   // this logic is for considerate shouldContinue when buttons lock/open is not visible
    //   if (!canUpdateAvailabilities && !shouldContinue) return;

    //   // this logic is for considerate shouldContinue when buttons lock/open is visible and allow open or close all slots
    //   if (canUpdateAvailabilities && shouldContinue) {
    //     if (!this.isAvailabilityBlock) {
    //       closeSlots = true;
    //     } else {
    //       openSlots = true;
    //     }
    //   }
    // } else {
    // this logic is for BYPASSING THE ENORMOUS INSANITY ABOVE.
    const shouldContinue = await confirm.yesno(tr("Are you sure you want to save the changes?"), tr("Save"), tr("Back"));

    if (!shouldContinue) {
      this.saveDisabled = false;
      return;
    }
    // }

    this.saveReservation(openSlots, closeSlots);
  }

  validateReservationData(): boolean {
    const missingFields = this.revealReservationFieldErrors();

    const reservation_experience = this.experience;
    if (!reservation_experience) {
      toast("Before saving the reservation, make sure to select the experience").then();
      return false;
    }

    if (missingFields) return false;

    if (this.form.get("reservation")?.get("total")?.value < 0) {
      toast("Total can't be negative").then();
      return false;
    }

    if (!this.isDraft) {
      let validateContact = function (contact: any): boolean {
        return !contact || (!contact.firstName && !contact.lastName && !contact.email && !contact.phoneNumber && !contact.countryIso);
      };
      if (validateContact(this.masterContactControl?.value)) {
        toast("Please add the main contact").then();
        return false;
      }
      if (this.secondaryContactsControls?.reduce((acc, control) => acc || validateContact(control.value), false)) {
        toast("Please delete the empty participants or fill in the respective data").then();
        return false;
      }
    }

    return true;
  }

  reservationFieldInvalid(name: "date" | "time" | "event_date" | "lang" | "experience_price_labels"): boolean {
    return this.reservationFieldErrorsVisible && this.isReservationFieldMissing(name);
  }

  private revealReservationFieldErrors(): boolean {
    const reservation = this.form.get("reservation");
    if (!reservation) return false;

    this.updateEventDateFieldValidators();
    this.ensureEditableLanguageControl();

    const names = this.useEventDatePicker
      ? (["event_date", "lang", "experience_price_labels"] as const)
      : (["date", "time", "lang", "experience_price_labels"] as const);

    let firstInvalid: (typeof names)[number] | null = null;
    for (const name of names) {
      if (name !== "experience_price_labels") {
        const ctrl = reservation.get(name);
        if (ctrl && ctrl.enabled) ctrl.updateValueAndValidity({ emitEvent: false });
      }
      if (!this.isReservationFieldMissing(name)) continue;
      reservation.get(name)?.markAsTouched();
      if (!firstInvalid) firstInvalid = name;
    }

    if (!firstInvalid) return false;

    this.reservationFieldErrorsVisible = true;
    this.cdr.markForCheck();
    this.scrollToReservationField(firstInvalid);
    return true;
  }

  private ensureEditableLanguageControl(): void {
    if (!this.canEditCoreInfo || (this.reservationToClone && !this.isNewReservationFromCalendar)) return;
    if (!this.experienceLanguages?.length || this.isLanguageFieldDisabled) return;
    const ctrl = this.form.get("reservation")?.get("lang");
    if (ctrl?.disabled) ctrl.enable({ emitEvent: false });
  }

  private isReservationFieldMissing(name: string): boolean {
    if (name === "experience_price_labels") return this.participantsQuantity() <= 0;
    const ctrl = this.form?.get("reservation")?.get(name);
    if (!ctrl || ctrl.disabled) return false;
    if (name === "lang") return !ctrl.value;
    return ctrl.invalid;
  }

  private participantsQuantity(): number {
    const labels = this.form?.get("reservation")?.get("experience_price_labels")?.value;
    if (!Array.isArray(labels)) return 0;
    return labels.reduce((sum: number, label: { quantity?: number }) => sum + (Number(label?.quantity) || 0), 0);
  }

  private scrollToReservationField(name: string): void {
    const elementId: Record<string, string> = {
      date: "reservation-date",
      time: "reservation-time",
      event_date: "reservation-event-date",
      lang: "reservation-lang",
      experience_price_labels: "participants-section",
    };
    const id = elementId[name];
    if (!id) return;
    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }

  async saveReservation(openSlots: boolean = false, closeSlots: boolean = false) {
    this.isSaving(true);
    try {
      let r = this.patchReservationFromForm();
      this.reservationDetailService.saveV2(r, openSlots, closeSlots).subscribe(
        (re) => {
          if (re.hasError) {
            toast(
              re.messages
                .filter((m: any) => m.type === "ERROR")
                .map((m: any) => m.message)
                .join("\n")
            );
            this.isSaving(false);
          } else {
            if (re.hasWarning) {
              toast(
                re.messages
                  .filter((m: any) => m.type === "WARN")
                  .map((m: any) => m.message)
                  .join("\n")
              );
            }
            this.reservationsService.updated$.next();
            this.waitForSaveReservationNew(re.reservation);
          }
        },
        (error) => {
          console.error(error + " - {}", this.messageError);
          toast(tr(this.messageError));
          this.isSaving(false);
        }
      );
    } catch (error) {
      console.error(error);
      toast(tr(this.messageError));
      this.isSaving(false);
    }
  }

  waitForSaveReservationNew(reservation: ReservationDTO) {
    if (reservation.id) this.manualReservationListenerService.addRequestIdToListener(reservation.id, reservation.id, reservation.state!);
    this.closeClick.emit(reservation);
  }

  /************************************** */

  addNewClientClicked(id: number | string) {
    this.startContactAddLoading();
    this.clientSaveCallback = (client: Client) => this.clientAdded(client);
    this.reservationContactToEditId = id;
    this.clientSideNav.open();
    setTimeout(() => this.trigger.closePanel());
  }

  removeClientClicked(id: number | string) {
    this.clients = [];
    this.form.controls.clientSearch.reset();
    this.searchControl.reset();
    const index = this.form
      .get("reservation")
      ?.get("reservationContacts")
      ?.value.findIndex((control: any) => control.id === id);
    (typeof id === "number" ? this.reservationContactsService.delete(id) : of(undefined)).subscribe(
      () => {
        (this.form.get("reservation")?.get("reservationContacts") as FormArray).removeAt(index);
        this.setContactsArraysWithValues();
        toast(tr("Resevation contact removed successfully"));
      },
      (error) => {
        toast(tr("Error deleting contact. Please try again."));
      }
    );
  }

  filterClients(value: any): any {
    const filterValue = this.normalizeValue(value);

    return this.clients.filter((client: any) => {
      const clientFullName =
        (client.firstName || "") + " " + (client.lastName || "");
      return this.normalizeValue(clientFullName).includes(filterValue);
    });
  }

  normalizeValue(value: string): any {
    if (typeof value === "string") {
      return value
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();
    }
  }

  associateContact(contact: DWS.Contact, id: number | string) {
    let idInternal = id;
    let control = (this.form.get("reservation")!.get("reservationContacts")! as FormArray).controls.find(
      (control: any) => control.get("id")?.value === idInternal
    );
    if (!control && this.masterContactControl) return;
    if (!control && !this.masterContactControl) {
      const newId = (crypto as any).randomUUID();
      let fg = this.fb.group({
        id: [newId],
        name: [""],
        firstName: [""],
        lastName: [""],
        email: [""],
        phoneNumber: [""],
        countryIso: [""],
        contactType: ["MASTER"],
        crmContactId: [""],
        manualMarketing: [false],
      });
      (this.form.get("reservation")!.get("reservationContacts") as FormArray).push(fg);
      control = this.masterContactControl;
      idInternal = newId;
    }
    control!.patchValue({
      name: contact.name,
      firstName: !contact.firstName && !contact.lastName ? contact.companyName : contact.firstName,
      lastName: contact.lastName || "",
      email: contact.email,
      phoneNumber: contact.phone,
      countryIso: contact.countryOfResidenceIso,
      crmContactId: contact.id,
    });

    this.contactsData[idInternal] = {} as any;
    this.contactDetailOpen[idInternal] = false;
    this.contactsNotMatchingAlerts[idInternal] = {};

    this.retrieveCRMData(contact, idInternal, contact.id!);

    this.form.controls.clientSearch.reset();
    this.masterSearchControl.reset();
    this.searchControl.reset();
  }

  /**
   * Updates a reservation contact in the form and synchronizes it with CRM data.
   *
   * This method finds the contact currently being edited, updates its details in the form,
   * checks for discrepancies with the corresponding CRM contact, and handles any mismatches
   * by either showing alerts or updating the CRM record if needed.
   *
   * @param contact - The updated reservation contact data from the form.
   * @param crmContact - (Optional) The related contact data from the CRM system.
   */
  async patchClient(contact: DWS.Reservation.ReservationContactDTO, crmContact?: DWS.Contact) {
    let isEmailChanged = false,
      index = undefined;
    // Get the FormArray containing the reservation contacts from the form
    const reservationContacts = this.form.get("reservation")?.get("reservationContacts") as FormArray;
    if (!reservationContacts) {
      if (this.contactAddFlowPending) {
        this.clearContactAddLoading();
      }
      return;
    }
    // Find the contact index that matches the one being edited
    index = reservationContacts.controls.findIndex((control: any) => control.get("id")?.value === this.reservationContactToEditId);
    if (index === -1) return;
    const isMasterTourOperator =
      this.isTourOperator &&
      reservationContacts.at(index).get("contactType")?.value === "MASTER";
    // Check if the contact's email has changed or if CRM contact has an email
    isEmailChanged = reservationContacts.at(index).get("email")!.value !== contact?.email || !!crmContact?.email;
    // Update the contact values in the form with the new contact data
    reservationContacts.at(index).patchValue({
      id: contact?.id || this.reservationContactToEditId,
      firstName: contact?.firstName,
      lastName: isMasterTourOperator ? "" : contact?.lastName ?? "",
      email: contact?.email,
      phoneNumber: contact?.phoneNumber,
      countryIso: contact?.countryIso,
      manualMarketing: contact?.manualMarketing,
      ...(crmContact?.id != null ? { crmContactId: crmContact.id } : {}),
    });
    // Initialize an empty alert object for potential mismatched fields
    this.contactsNotMatchingAlerts[reservationContacts.at(index)?.get("id")?.value] = {};
    // Compare CRM contact data with form contact data and track mismatches
    if (crmContact) {
      // Retrieve CRM data if email has changed
      isEmailChanged &&
        this.retrieveCRMData(
          contact,
          this.reservationContactToEditId!,
          crmContact.id!
        );
      // Check for mismatched fields (Email, First name, Last name, etc.)
      if (crmContact.email !== contact.email)
        this.contactsNotMatchingAlerts[reservationContacts.at(index)?.get("id")?.value][tr("Email")] = crmContact.email || "-";
      if (crmContact.firstName !== contact.firstName && crmContact.firstName?.replace("_", "") !== contact.firstName)
        this.contactsNotMatchingAlerts[reservationContacts.at(index)?.get("id")?.value][tr("First name")] = crmContact.firstName || "-";
      if (crmContact.lastName !== contact.lastName && crmContact.lastName?.replace("_", "") !== contact.lastName)
        this.contactsNotMatchingAlerts[reservationContacts.at(index)?.get("id")?.value][tr("Last name")] = crmContact.lastName || "-";
      if (crmContact.phone !== contact.phoneNumber)
        this.contactsNotMatchingAlerts[reservationContacts.at(index)?.get("id")?.value][tr("Phone")] = crmContact.phone || "-";
      if (crmContact.countryOfResidenceIso !== contact.countryIso)
        this.contactsNotMatchingAlerts[reservationContacts.at(index)?.get("id")?.value][tr("Country of Residence")] = crmContact.countryOfResidenceIso || "-";
      // Handle case where company name equals first name (special correction)
      if (crmContact.companyName == contact.firstName) {
        delete this.contactsNotMatchingAlerts[reservationContacts.at(index)?.get("id")?.value][tr("First name")];
        delete this.contactsNotMatchingAlerts[reservationContacts.at(index)?.get("id")?.value][tr("Last name")];
      }
    }
    // If there are mismatched fields, update CRM contact; otherwise clear alerts
    try {
      if (this.objectKeys(this.contactsNotMatchingAlerts[reservationContacts.at(index)?.get("id")?.value])?.length) {
        await this.updateCRMContactOrDoNothing(crmContact!.id!, contact);
      } else {
        this.contactsNotMatchingAlerts[reservationContacts.at(index)?.get("id")?.value] = {};
      }
      if (crmContact?.id != null) {
        this.refreshClientsListAndPreselect(this.isMasterReservationContact(), crmContact);
      } else if (this.contactAddFlowPending) {
        this.clearContactAddLoading();
      }
    } catch {
      if (this.contactAddFlowPending) {
        this.clearContactAddLoading();
      }
    }
  }

  private clearContactAddLoading(): void {
    this.loadingContactAdd = false;
    this.contactAddFlowPending = false;
    this.cdr.markForCheck();
  }

  private startContactAddLoading(): void {
    this.loadingContactAdd = true;
    this.contactAddFlowPending = true;
    this.cdr.markForCheck();
  }

  private isMasterReservationContact(): boolean {
    return this.reservationContactToEditId === this.masterContactControl?.get("id")?.value;
  }

  /** After creating or linking a CRM contact, reload the autocomplete list and show the selected contact (WS-2420). */
  private refreshClientsListAndPreselect(isMaster: boolean, contact: DWS.Contact) {
    if (!contact?.id) {
      if (this.contactAddFlowPending) {
        this.clearContactAddLoading();
      }
      return;
    }
    const q = contact.email || contact.name || undefined;
    this.contactsService
      .list({
        q,
        wineryIds: [this.companyId],
        includeUnsubscribed: false,
        includeSubscribed: false,
        tourOperators: this.isTourOperator && isMaster,
      })
      .pipe(
        catchError(() => of({ content: [] } as unknown as Page<Contact>)),
        finalize(() => {
          if (this.contactAddFlowPending) {
            this.clearContactAddLoading();
          }
          this.cdr.markForCheck();
        })
      )
      .subscribe((page: Page<Contact>) => {
        const withEmail = page.content.filter((c) => c.email != null);
        this.clients = withEmail.length > 0 ? withEmail : [contact];
        const picked = this.clients.find((c) => c.id === contact.id) ?? contact;
        const ctrl = isMaster ? this.masterSearchControl : this.searchControl;
        ctrl.setValue(picked, { emitEvent: false });
      });
  }

  displayClientForAutocomplete(value: Contact | string | null): string {
    if (value == null || typeof value === "string") {
      return typeof value === "string" ? value : "";
    }
    return (
      value.name ||
      [value.firstName, value.lastName].filter(Boolean).join(" ").trim() ||
      value.email ||
      ""
    );
  }

  retrieveCRMData(contact: DWS.Reservation.ReservationContactDTO, id: number | string, crmId: number) {
    this.statisticsService.get(crmId, contact.email, this.companyId).subscribe((statistics) => {
      this.contactsData[id].contactStatistics = statistics;
    });
    this.contactsTagsService
      .list({
        contactId: crmId,
        wineryId: this.companyId,
      })
      .subscribe((tags) => {
        this.contactsData[id].contactTags = tags.content;
      });
    this.contactsService.getByEmail(contact.email!).subscribe((contact) => {
      this.contactsData[id].contactPrivacy = {
        acceptedPrivacyTerms: contact.acceptedPrivacyTerms,
        acceptedMarketing: contact.acceptedMarketing,
        acceptedProfiling: contact.acceptedProfiling,
        manualMarketing: contact.manualMarketing,
        unsubscribed: contact.unsubscribed,
      };
      this.allContactsControls
        .find((control) => control.get("id")?.value === id)
        ?.patchValue({
          manualMarketing: contact.manualMarketing,
        });
    });
  }

  showClientList() {
    setTimeout(() => this.trigger.openPanel());
  }

  clientAdded(client: Client) {
    if (!this.loadingContactAdd) {
      this.startContactAddLoading();
    }
    const dto = {
      ...client,
      firstName: client.firstname,
      lastName: client.lastname,
    } as DWS.Reservation.ReservationContactDTO;
    if (client.id) {
      this.contactsService
        .getv2(Number(client.id), this.companyId)
        .pipe(
          catchError(() => {
            this.clearContactAddLoading();
            return of(undefined);
          })
        )
        .subscribe((c) => {
          void this.patchClient(dto, c ?? undefined);
        });
      return;
    }
    if (client.email) {
      this.contactsService
        .getByEmail(client.email)
        .pipe(
          catchError(() => {
            this.clearContactAddLoading();
            return of(undefined);
          })
        )
        .subscribe((c) => {
          if (c?.id) {
            this.contactsService
              .getv2(c.id, this.companyId)
              .pipe(
                catchError(() => {
                  this.clearContactAddLoading();
                  return of(undefined);
                })
              )
              .subscribe((c2) => {
                void this.patchClient(dto, c2 ?? undefined);
              });
          } else {
            void this.patchClient(dto);
          }
        });
      return;
    }
    void this.patchClient(dto);
  }

  editClientClicked(id: number | string) {
    this.reservationContactToEditId = id;
    this.clientSaveCallback = (client: Client) => this.clientAdded(client);
    this.clientSideNav.open();
  }

  experienceChanged() {
    if (!this.experience) return;

    // Log experience titles and descriptions
    // console.log("Selected experience:", this.experience);
    // console.log(
    //   "Experience titles_translations:",
    //   this.experience.details?.titles
    // );
    // console.log(
    //   "Experience short descriptions:",
    //   this.experience.details?.shortDescriptions
    // );

    if (this.experienceType == "event") {
      this.experienceEventsAvailabilitiesService.showExperienceEvents(this.experience!.id).subscribe((events) => {
        this.eventDates = events.map((e) => e.day + " " + e.time);
        if (this.reservation?.date && this.reservation?.time) {
          const newEventDate = `${this.reservation.date} ${this.reservation.time}`;
          const alreadyListed = this.eventDates.some((value) => {
            const [day, time] = value.split(" ");
            return day === this.reservation?.date && time === this.reservation?.time;
          });
          if (!alreadyListed) {
            this.eventDates.push(newEventDate);
          }
          this.form.get("reservation")?.get("event_date")?.setValue(newEventDate);
        }
        this.updateEventDateFieldValidators();
        this.cdr.markForCheck();
      });
    } else {
      if (!!!!this.form.get("reservation")?.get("date")?.value) {
        // SE C?é UNA DATA NELLA FORM
        var d = this.form.get("reservation")?.get("date")?.value;
        this.updateAvailabilitiesList(this.experience.id, d);
      }
    }

    if (this.reservation) {
      const reservationDate = this.eventDates.find((value) => {
        const [day, time] = value.split(" ");
        return day === this.reservation?.date && time === this.reservation.time;
      });
      if (reservationDate == null) {
        let newEventDate = `${this.reservation.date} ${this.reservation.time}`;
        this.eventDates.push(newEventDate);
        this.form.get("reservation")!.get("event_date")!.setValue(newEventDate);
      } else {
        this.form.get("reservation")!.get("event_date")!.setValue(reservationDate);
      }
    }
    if (this.reservationToClone) {
      const reservationDate = this.eventDates.find((value) => {
        const [day, time] = value.split(" ");
        return day === this.reservationToClone?.date && time === this.reservationToClone.time;
      });
      if (reservationDate == null) {
        let newEventDate = `${this.reservationToClone.date} ${this.reservationToClone.time}`;
        this.eventDates.push(newEventDate);
        this.form.get("reservation")!.get("event_date")!.setValue(newEventDate);
      } else {
        this.form.get("reservation")!.get("event_date")!.setValue(reservationDate);
      }
    }

    if (this.experienceType == "event") {
      this.updateEventDateFieldValidators();
      if ((this.reservationToClone || this.reservation) && this.form.get("reservation")!.get("event_date")! && this.useEventDatePicker) {
        // Disabilita event_date solo se NON è una nuova prenotazione dal calendario
        if (!this.isNewReservationFromCalendar) {
          this.form.get("reservation")?.get("event_date")?.disable();
        }
      }
    }
    if (this.form && this.reservationToClone && this.form.get("reservation") && this.canEdit) {
      // Don't clear fields if this is a new reservation from calendar
      if (this.reservationToClone && this.reservationToClone.experienceId !== this.experience.id && !this.isNewReservationFromCalendar) {
        this.form.patchValue({
          reservation: {
            date: "",
            time: "",
            event_dates: "",
            event_date: "",
            lang: "",
          },
        });
      } else {
        this.form.patchValue({
          reservation: {
            date: this.reservationToClone?.date,
            time: this.reservationToClone?.time,
            interval: this.experience.details.duration,
            lang: this.reservationToClone?.languageIso,
          },
        });
      }

      const r = this.form.get("reservation")!;

      if (!this.reservationToClone) {
        r.get("lang")!.enable();
        r.get("date")!.enable();
        r.get("time")!.enable();
        if (r.get("event_date")!) {
          r.get("event_date")!.enable();
        }
      } else {
        // Se è una nuova prenotazione dal calendario, abilita i campi date e time
        if (this.isNewReservationFromCalendar) {
          r.get("date")!.enable();
          r.get("time")!.enable();
          if (r.get("event_date")!) {
            r.get("event_date")!.enable();
          }
        }

        if (!!!!this.reservationToClone.language) {
          r.get("lang")!.disable();
        }
      }

      r.get("total")!.enable();
    }

    this.fillPriceLabels();
    this.fillPriceExtras();

    this.availableLanguages = this.experienceLanguages;

    // Update form control states after experience changes to ensure language field is properly enabled/disabled
    this.updateFormControlStates();

    // Trigger change detection for OnPush strategy
    this.cdr.markForCheck();
  }

  updateAvailabilitiesList(experienceId: string, date: any) {
    var date2: Date;
    if (typeof date === "string") {
      date2 = parseISO(date);
    } else if (date instanceof Date) {
      date2 = date;
    } else if (moment.isMoment(date)) {
      date2 = date.toDate();
    } else {
      return;
    }

    if (!!!date2) return;
    // if invaliddate return
    if (isNaN(date2.getTime())) return;
    if (!!!experienceId) return;

    observe(
      this.availabilityServiceDws.getAvailabilitiesByExperienceAndDate(
        experienceId,
        date2
      ),
      false
    ).pipe(
      takeUntil(this.destroy$)
    ).subscribe((availabilities) => {
      this.batchFormUpdates(() => {
        this.availableAvailabilities = availabilities;
        this.availableTimes = [];
        if (availabilities && availabilities.length > 0) {
          this.availableTimes = availabilities.map((a) => {
            return a.time.split(":").slice(0, 2).join(":");
          });

            //if (this.reservation?.type === "automatic") {
            //  if (this.availableTimes.length == 0){
            //    this.availableTimes.push(
            //      this.reservation!.time!.split(":", 2).join(":")
            //    );
            //  }
            //}

            // DISTINCT
            this.availableTimes = [...new Set(this.availableTimes)];
            // SORT availableTimes
            this.availableTimes = this.availableTimes.sort((a, b) => {
              return a.localeCompare(b);
            });
          }
          this.form.get("reservation")?.get("time")?.enable();
          // Clear count cache when availability data changes
          this.clearCountCache();
        });
      });
  }

  displayDate(date: string) {
    return _.capitalize(moment(date).locale("it").format("dddd, DD MMMM YYYY [h]HH:mm"));
  }

  private updateEventDateFieldValidators(): void {
    const r = this.form.get("reservation");
    if (!r || this.experienceType !== "event") {
      return;
    }
    if (this.eventDates.length > 0) {
      r.get("event_date")?.setValidators(Validators.required);
      r.get("date")?.clearValidators();
      r.get("time")?.clearValidators();
    } else {
      r.get("event_date")?.clearValidators();
      r.get("date")?.setValidators(Validators.required);
      r.get("time")?.setValidators(Validators.required);
    }
    r.get("event_date")?.updateValueAndValidity({ emitEvent: false });
    r.get("date")?.updateValueAndValidity({ emitEvent: false });
    r.get("time")?.updateValueAndValidity({ emitEvent: false });
  }

  formatRefundDate(refundDate: Date | undefined): string {
    if (!refundDate) {
      return "";
    }
    return formatUtcTimestampRome(refundDate, "dd/MM/yyyy HH:mm");
  }

  formatRefundDateBadge(refundDate: Date | undefined): string {
    if (!refundDate) {
      return "";
    }
    return formatUtcTimestampRome(refundDate, "dd/MM/yyyy");
  }

  async confirmReservationClicked() {
    var reservationId = this.reservationId!;

    const doThings = () => {
      var that = this as any;
      that.isSaving(true);

      that.manualReservationListenerService.addRequestIdToListener(reservationId, reservationId, that.reservation!.state!);

      that.reservationDetailService.confirmReservationV2(reservationId).subscribe(
        (request: any) => {
          that.isSaving(false);

          const failed =
            request?.otherData?.paymentFailed === true || request?.otherData?.paymentFailed === "true";
          if (failed) {
            that.checkIfPaymentFailed(request);
            return;
          }

          that.closeClick.emit();
        },
        (err: any) => {
          toast(tr(err));
          that.isSaving(false);
        }
      );
    };

    this.markCalculatedFieldsAsPristine();
    if (this.form.pristine && this.clientForm.pristine) {
      const sure = await confirm.yesno(tr("Are you sure you want to confirm the reservation?"), tr("Yes"), tr("Back"));
      if (!sure) return;
    } else {
      const r = await confirm.yesno(
        tr(
          "You are about to confirm the reservation without having saved the changes just made. Make sure to save the changes before proceeding with the confirmation. Do you want to save the changes now?"
        ),
        tr("Save and Confirm"),
        tr("Confirm without saving")
      );
      if (r) {
        //this.form.get("reservation")!.get("status")!.setValue(ReservationDetail.status(undefined, "confirmed"));
        await this.saveReservation(false, false);
      } else {
        return;
      }
    }
    doThings();
  }

  getDuration(): string {
    var duration = "";
    if (this.experience) {
      duration = this.experience.details.duration;
    }

    const durationPattern = /(\d+d)?\s*(\d+h)?\s*(\d+m)?/;
    const match = duration.match(durationPattern);

    if (match) {
      const days = match[1] && match[1] != "0d" ? match[1].trim() : "";
      const hours = match[2] && match[2] != "0h" ? match[2].trim() : "";
      const minutes = match[3] && match[3] != "0m" ? match[3].trim() : "";

      // Construct the new duration string, omitting zero values
      duration = `${days ? days : ""}${days && hours ? " " : ""}${hours ? hours : ""}${(days || hours) && minutes ? " " : ""}${minutes ? minutes : ""}`.trim();
    }

    return duration;
  }

  async rejectReservationClicked() {
    var reservationId = this.reservationId!;
    const sure = await confirm.yesno(tr("Are you sure you want to reject the reservation?"), tr("Yes"), tr("Back"));
    if (!sure) return;
    this.isSaving(true);

    this.manualReservationListenerService.addRequestIdToListener(reservationId, reservationId, this.reservation!.state!);

    this.reservationDetailService.rejectReservationV2(reservationId).subscribe(
      (request) => {
        this.isSaving(false);

        this.closeClick.emit();
      },
      (err) => {
        console.error(err);
        toast(tr(this.messageError));
        this.isSaving(false);
      }
    );
  }

  async cancelReservationClicked() {
    var reservationId = this.reservationId!;
    const sure = await confirm.yesno(tr("Are you sure you want to delete the reservation?"), tr("Yes"), tr("Back"));
    if (!sure) return;
    this.isSaving(true);

    this.manualReservationListenerService.addRequestIdToListener(reservationId, reservationId, this.reservation!.state!);

    this.reservationDetailService.cancelReservationV2(reservationId).subscribe(
      (request) => {
        this.isSaving(false);
        this.closeClick.emit();
      },
      (err) => {
        console.error(err);
        toast(tr(this.messageError));
        this.isSaving(false);
      }
    );
  }

  async revokeReservationClicked() {
    var reservationId = this.reservationId!;
    
    let result: RevokeReservationDialogResult | boolean | undefined;
    if(this.isDwspayPayment){
      const dialogRef = this.dlg.open(RevokeReservationDialogComponent, {
        width: '600px',
        disableClose: false,
        data: {
          shouldAskForSlotClosing: this.shouldAskForSlotClosing,
          reservationId: reservationId,
          isDwspayPayment: this.isDwspayPayment,
          isPaid: this.reservation?.paid || false,
          paymentRefunded: this.paymentRefunded,
          paidAmount: (this.reservation?.netTotalCents || 0) / 100,
          currencySymbol: this.currencySymbol
        }
      });    
      result = await dialogRef.afterClosed().toPromise();
      if (!result || typeof result !== 'object' || !result.confirmed) return;
    } else{
    var mex = tr("revoke_dialog.main_message");
    if (this.shouldAskForSlotClosing) {
      mex = tr(
        'You are about to revoke a confirmed reservation. Please check if it is necessary to reopen the availability slots in the "Availability Management" section and make the language available again for future customers. Do you want to proceed with the cancellation?'
      );
    }
    result = await confirm.yesno(mex, tr("Confirm!"), tr("Cancel"));
    if (!result) return;
    }

    this.isSaving(true);

    this.manualReservationListenerService.addRequestIdToListener(reservationId, reservationId, this.reservation!.state!);

    this.reservationDetailService.revokeReservationV2(reservationId).subscribe(
      (request) => {
        if (result && typeof result === 'object' && result.shouldRefund) {
          this.processRefund(reservationId);
        } else {
          this.isSaving(false);
          this.closeClick.emit();
        }
      },
      (err) => {
        console.error(err);
        toast(tr(this.messageError));
        this.isSaving(false);
      }
    );
  }

  private processRefund(reservationId: string) {
    this.reservationDetailService.refundReservationV2(reservationId).subscribe(
      (request) => {
        this.isSaving(false);
        toast(tr("Refund processed successfully"));
        this.paymentRefunded = true;
        this.cd.detectChanges();
        this.closeClick.emit();
      },
      (err) => {
        console.error(err);
        const errorMessage = err?.error?.message || err?.message || this.messageError;
        toast(tr(errorMessage));
        this.isSaving(false);
        this.closeClick.emit();
      }
    );
  }

  async refundReservationClicked() {
    var reservationId = this.reservationId!;
    
    // Get customer name from master contact
    const masterContact = this.masterContactControl;
    const firstName = masterContact?.get('firstName')?.value || '';
    const lastName = masterContact?.get('lastName')?.value || '';
    const customerName = `${firstName} ${lastName}`.trim() || 'N/A';
    
    const dialogRef = this.dlg.open(RefundPaymentDialogComponent, {
      width: '550px',
      disableClose: false,
      data: {
        reservationId: reservationId,
        customerName: customerName,
        paidAmount: (this.reservation?.netTotalCents || 0) / 100,
        currencySymbol: this.currencySymbol,
        paymentDate: this.reservation?.createdAt || new Date().toISOString()
      }
    });

    const result = await dialogRef.afterClosed().toPromise();
    if (!result || !result.confirmed) return;
    
    this.isSaving(true);

    this.manualReservationListenerService.addRequestIdToListener(reservationId, reservationId, this.reservation!.state!);

    this.reservationDetailService.refundReservationV2(reservationId).subscribe(
      (request) => {
        this.isSaving(false);
        toast(tr("Refund processed successfully"));
        this.paymentRefunded = true;
        this.refundDate = new Date();
        this.patchRefundedAmount();
        this.reservationUpdated.emit(this.reservation);
        this.cdr.markForCheck();
        if (this.reservationId) {
          this.reservationDetailService.getV2(this.reservationId).subscribe(
            (reservation) => {
              this.reservation = reservation;
              this.checkPaymentRefunded();
              this.patchRefundedAmount();
              this.reservationUpdated.emit(this.reservation);
              this.cdr.markForCheck();
            }
          );
        }
      },
      (err) => {
        console.error(err);
        const errorMessage = err?.error?.message || err?.message || this.messageError;
        toast(tr(errorMessage));
        this.isSaving(false);
      }
    );
  }

  get isDwspayPayment(): boolean {
    const pm = this.form?.get('reservation')?.get('payment_method')?.value;
    const pm2 = this.form?.get('reservation')?.get('payment2_method')?.value;
    if (pm?.code === 'dwspay' || pm2?.code === 'dwspay') {
      return true;
    }
    return this.hasDwspayPaymentEvidence();
  }

  get hasDwspayPaymentDetailLink(): boolean {
    return this.paymentForDialog != null;
  }

  get paymentForDialog(): Payment | null {
    if (!this.isDwspayPayment && !this.hasDwspayPaymentEvidence()) {
      return null;
    }
    const stored = this.dwspayPaymentRecord;
    if (stored && ReservationDetailComponent.isDwspayWithPi(stored)) {
      return stored;
    }
    const piFromLink = this.paymentLinkData?.paymentIntentExternalId?.trim();
    if (piFromLink && ReservationDetailComponent.hasStripePiOrChargeId(piFromLink)) {
      return {
        id: stored?.id ?? 'from-payment-link',
        saleId: this.reservation?.id ?? '',
        provider: 'dwspay',
        method: stored?.method ?? 'card',
        externalId: piFromLink,
        status: this.isPaid() ? 'captured' : 'opened',
        currency: (this.reservation?.paymentCurrency ?? 'EUR').toLowerCase(),
        grossTotalCents: this.reservation?.netTotalCents ?? 0,
        createdAt: this.resolveReservationCreatedAtIso(),
      };
    }
    return null;
  }

  private static isDwspayWithPi(p: Payment): boolean {
    return String(p.provider || '').toLowerCase() === 'dwspay'
      && ReservationDetailComponent.hasStripePiOrChargeId(p.externalId);
  }

  private static hasStripePiOrChargeId(externalId: string | undefined): boolean {
    return !!externalId && /^(pi_|ch_)/.test(String(externalId).trim());
  }

  private hasDwspayPaymentEvidence(): boolean {
    const stored = this.dwspayPaymentRecord;
    if (stored && ReservationDetailComponent.isDwspayWithPi(stored)) {
      return true;
    }
    const piFromLink = this.paymentLinkData?.paymentIntentExternalId?.trim();
    return !!(
      piFromLink &&
      ReservationDetailComponent.hasStripePiOrChargeId(piFromLink) &&
      this.isPaid()
    );
  }

  private findDwspayPaymentMethods(): {
    payment_method: HostReservationFormOptions.PaymentMethod;
    payment2_method?: HostReservationFormOptions.PaymentMethod;
  } | null {
    const payment_method = this.paymentMethods.find((pm) => pm.code === 'dwspay');
    if (!payment_method) {
      return null;
    }
    const payment2_method =
      payment_method.children?.length === 1
        ? payment_method.children[0]
        : payment_method.children?.[0];
    return { payment_method, payment2_method };
  }

  private applyDwspayPaymentMethodsIfNeeded(): void {
    if (!this.hasDwspayPaymentEvidence()) {
      return;
    }
    const reservationGroup = this.form?.get('reservation');
    if (!reservationGroup) {
      return;
    }
    const currentPm = reservationGroup.get('payment_method')?.value;
    if (currentPm?.code === 'dwspay') {
      if (!reservationGroup.get('payment2_method')?.value) {
        this.selectPayment2MethodIfThereIsOnlyOne();
      }
      return;
    }
    if (currentPm) {
      return;
    }
    const dwspay = this.findDwspayPaymentMethods();
    if (!dwspay) {
      return;
    }
    reservationGroup.get('payment_method')!.setValue(dwspay.payment_method);
    if (dwspay.payment2_method) {
      reservationGroup.get('payment2_method')!.setValue(dwspay.payment2_method);
    } else {
      this.selectPayment2MethodIfThereIsOnlyOne();
    }
    this.cdr.markForCheck();
  }

  private resolveReservationCreatedAtIso(): string {
    const created = this.reservation?.createdAt;
    if (typeof created === 'string' && created.trim()) {
      return created;
    }
    return new Date().toISOString();
  }

  /** True when the linked dwspay payment has been fully refunded. */
  get isFullyRefunded(): boolean {
    const total = this.reservation?.netTotalCents ?? 0;
    if (total <= 0) {
      return this.paymentRefunded;
    }
    const refunded =
      this.reservation?.refundedTotalCents ??
      (this.reservation as any)?.otherData?.refundedTotalCents ??
      0;
    return refunded >= total || this.paymentRefunded;
  }

  /** Refund allowed on active paid reservations; does not require prior revoke. */
  get canRefundReservation(): boolean {
    if (this.paymentRefundStatusLoading || this.dwspayPaymentLoading) {
      return false;
    }
    if (!this.reservation || !this.isDwspayPayment || this.isFullyRefunded) {
      return false;
    }
    const state = this.reservation.state;
    const paid = this.reservation.paid || this.form?.get('reservation')?.get('paid')?.value;
    return !!paid && (state === 'confirmed' || state === 'completed' || state === 'revoked');
  }

  /** Grey badge shown after a full refund instead of the Refund button. */
  get showRefundStatusBadge(): boolean {
    return !!this.reservation && this.isFullyRefunded && this.hasRefundActivity;
  }

  get refundStatusBadgeLabel(): string {
    if (this.refundDate) {
      return `${tr('Refunded on')} ${this.formatRefundDateBadge(this.refundDate)}`;
    }
    return tr('Refunded');
  }

  /** Show refund date label after any refund activity (partial or full). */
  get hasRefundActivity(): boolean {
    if (this.paymentRefunded || this.refundDate) {
      return true;
    }
    const refunded =
      this.reservation?.refundedTotalCents ??
      (this.reservation as any)?.otherData?.refundedTotalCents ??
      0;
    return refunded > 0;
  }

  get isNexiPayment(): boolean {
    const pm = this.form?.get('reservation')?.get('payment_method')?.value;
    const pm2 = this.form?.get('reservation')?.get('payment2_method')?.value;
    return pm?.code === 'nexi' || pm2?.code === 'nexi';
  }

  /**
   * Checks if the dwspay payment has already been refunded by looking at reservation log history.
   * Hides the Refund button when payment was already refunded.
   */
  private checkPaymentRefunded(): void {
    if (!this.reservation?.id) {
      this.paymentRefunded = false;
      this.refundDate = undefined;
      this.paymentRefundStatusLoading = false;
      this.syncDwspayPaymentUiLoading();
      return;
    }

    const refundedAt =
      this.reservation.refundedAt || (this.reservation as any).otherData?.refundedAt;

    this.paymentRefundStatusLoading = true;
    this.cdr.markForCheck();

    this.reservationDetailService.getReservationHistory(this.reservation.id, 'payment')
      .pipe(
        take(1),
        finalize(() => {
          this.paymentRefundStatusLoading = false;
          if (this.initialPageLoadActive) {
            this.syncDwspayPaymentUiLoading();
          }
          this.cdr.markForCheck();
        }),
      )
      .subscribe({
        next: (logs) => {
          const refundLog = Array.isArray(logs) && logs.find(
            (log: any) => log?.details && (log.details as any)?.action === 'refund'
          );
          if (refundLog) {
            const partial = (refundLog.details as any)?.partial === true;
            this.paymentRefunded = !partial;
            this.refundDate = refundLog.updateTimestamp ? new Date(refundLog.updateTimestamp) : undefined;
          } else if (refundedAt) {
            const totalCents = this.reservation?.netTotalCents ?? 0;
            const refundedCents =
              this.reservation?.refundedTotalCents ??
              (this.reservation as any)?.otherData?.refundedTotalCents ??
              0;
            this.paymentRefunded = totalCents > 0
              ? (refundedCents >= totalCents || refundedCents <= 0)
              : true;
            this.refundDate = typeof refundedAt === 'string' ? parseISO(refundedAt) : new Date(refundedAt);
          } else {
            this.paymentRefunded = false;
            this.refundDate = undefined;
          }
          this.patchRefundedAmount();
          this.cd.detectChanges();
        },
        error: () => {
          if (refundedAt) {
            const totalCents = this.reservation?.netTotalCents ?? 0;
            const refundedCents =
              this.reservation?.refundedTotalCents ??
              (this.reservation as any)?.otherData?.refundedTotalCents ??
              0;
            this.paymentRefunded = totalCents > 0
              ? (refundedCents >= totalCents || refundedCents <= 0)
              : true;
            this.refundDate = typeof refundedAt === 'string' ? parseISO(refundedAt) : new Date(refundedAt);
          } else {
            this.paymentRefunded = false;
            this.refundDate = undefined;
          }
          this.patchRefundedAmount();
          this.cd.detectChanges();
        }
      });
  }

  private resolveRefundedAmountEuros(r?: VwReservation | null): number {
    if (!r) return 0;
    const cents =
      r.refundedTotalCents ??
      (r as any).otherData?.refundedTotalCents ??
      0;
    return cents > 0 ? cents / 100 : 0;
  }

  private patchRefundedAmount(): void {
    const ctrl = this.form?.get("reservation")?.get("refundedAmount");
    if (!ctrl) return;
    ctrl.setValue(this.resolveRefundedAmountEuros(this.reservation));
    this.cd.detectChanges();
  }

  isSaving(start: boolean) {
    if (start) {
      this.saveDisabled = start;
      this.isConfirmingOrRejecting = start;

      toast(tr("Saving..."));
    } else {
      this.saveDisabled = false;
      this.isConfirmingOrRejecting = false;
    }
  }

  returnToGift() {
    this.returnGift.emit();
  }

  monthSelected(month: Moment) {
    this.monthpicker.close();
    const start = month.toDate(),
      end = month.endOf("month").toDate();
    this.loading = true;
    this.experienceAvailabilitiesService
      .get(this.experience!.id, { start, end })
      .subscribe((daysAvailability) => {
        this.availabilities = daysAvailability;
        this.dateAvailableFilter = (d: Moment) => {
          return ExperienceAvailability.isDayAvailable(daysAvailability, d.toDate(), this.company.company_closings);
        };
        this.datepicker.startAt = month;
        this.datepicker.open();
      })
      .add(() => (this.loading = false));
  }

  hasClientAssocieted(id: number | string | undefined): boolean {
    if (!id) return false;
    const rc = (this.form.get("reservation")?.get("reservationContacts") as FormArray).controls.find((control: any) => control.get("id")?.value === id);
    if (!rc) return false;
    else
      return rc.get("firstName")?.value || rc.get("lastName")?.value || rc.get("email")?.value || rc.get("phoneNumber")?.value || rc.get("countryIso")?.value;
  }

  addClientRequested(callback: (client: Client) => void) {
    this.clientSaveCallback = callback;
    this.clientSideNav.open();
  }

  private async updateCRMContactOrDoNothing(contactId: number, contact: any, callback?: Function, force: boolean = false) {
    if (force || (await confirm.yesno(tr("Do you want to update the data in the CRM?")))) {
      this.contactsService.updateShort(contactId, contact).subscribe(
        () => {
          toast(tr("Contact updated successfully"));
          this.contactsNotMatchingAlerts[this.masterContactControl?.get("id")?.value] = {};
          callback && callback();
        },
        () => {
          toast(tr(this.messageError));
        }
      );
    }
  }

  private askForAssociationWithExistingContactAndPatchClient(CRMContact: DWS.Contact, currentContact: any) {
    this.clearContactAddLoading();
    this.dlg
      .open(ContactAssociationComponent, {
        data: { contact: CRMContact },
      })
      .afterClosed()
      .subscribe((yesClicked) => {
        if (yesClicked) {
          const reservationContacts = this.form.get("reservation")?.get("reservationContacts") as FormArray;
          const index = reservationContacts.controls.findIndex((control: any) => control.get("id")?.value === this.reservationContactToEditId);
          reservationContacts.at(index).get("crmContactId")!.setValue(CRMContact.id);
          void this.patchClient(currentContact, CRMContact);
        } else {
          void this.patchClient(currentContact);
        }
      });
  }

  clientCloseClicked(contact: DWS.Reservation.ReservationContactDTO | undefined) {
    this.clientSideNav.close();
    if (contact === undefined) {
      this.clearContactAddLoading();
      return;
    }

    this.startContactAddLoading();

    if (!this.reservationContactToEditId) {
      const newId = (crypto as any).randomUUID();
      let fg = this.fb.group({
        id: [contact.id || newId],
        name: [""],
        firstName: [""],
        lastName: [""],
        email: [""],
        phoneNumber: [""],
        countryIso: [""],
        contactType: ["MASTER"],
        crmContactId: [""],
        manualMarketing: [false],
      });
      (this.form.get("reservation")!.get("reservationContacts") as FormArray).push(fg);
      this.reservationContactToEditId = contact.id || newId;
    }

    this.contactsData[this.reservationContactToEditId!] = {} as any;
    this.contactDetailOpen[this.reservationContactToEditId!] = false;
    this.contactsNotMatchingAlerts[this.reservationContactToEditId!] = {};

    this.clients = [];
    let crmContactId = this.allContactsControls.find((control: any) => control.get("id")?.value == this.reservationContactToEditId)?.get("crmContactId")?.value;

    const contactControl = this.allContactsControls.find((control: any) => control.get("id")?.value == this.reservationContactToEditId);

    if (!!crmContactId || !!contact.email) {
      (!!crmContactId ? of(crmContactId) : this.contactsService.getByEmail(contact.email!).pipe(map((c) => c?.id)))
        .pipe(
          catchError(() => {
            this.clearContactAddLoading();
            return of(null as number | null | undefined);
          })
        )
        .subscribe((contactId) => {
          if (contactId) {
            this.contactsService
              .getv2(contactId, this.companyId)
              .pipe(
                catchError(() => {
                  this.clearContactAddLoading();
                  return of(undefined);
                })
              )
              .subscribe((contactInt) => {
                if (contactInt && (!crmContactId || crmContactId != contactInt.id)) {
                  this.askForAssociationWithExistingContactAndPatchClient(contactInt, contact);
                } else if (!contactInt && contactId) {
                  this.contactsNotMatchingAlerts[this.masterContactControl?.get("id")?.value] = {};
                  this.contactsNotMatchingAlerts[this.masterContactControl?.get("id")?.value][tr("Email")] = contactControl?.get("email")?.value;
                  this.updateCRMContactOrDoNothing(contactControl!.get("crmContactId")!.value, contact, this.patchClient.bind(this, contact), true);
                } else {
                  void this.patchClient(contact, contactInt);
                }
              });
          } else if (contact) {
            void this.patchClient(contact);
          } else {
            this.clearContactAddLoading();
          }
        });
    } else {
      void this.patchClient(contact);
    }
  }

  @ViewChild("datepicker", { static: false })
  datepicker!: MatDatepicker<Moment>;
  @ViewChild("monthpicker", { static: false })
  monthpicker!: MatDatepicker<Moment>;

  get secondaryContactsControls() {
    return (this.form.get("reservation")?.get("reservationContacts") as FormArray)?.controls.filter((rc) => rc.get("contactType")?.value != "MASTER");
  }

  get allContactsControls() {
    return (this.form.get("reservation")?.get("reservationContacts") as FormArray)?.controls;
  }

  get masterContactControl() {
    return (this.form.get("reservation")?.get("reservationContacts") as FormArray)?.controls.find((rc) => rc.get("contactType")?.value == "MASTER");
  }

  get sideNavContact() {
    return (
      (this.form.get("reservation")?.get("reservationContacts") as FormArray)?.controls.find((rc) => rc.get("id")?.value == this.reservationContactToEditId)
        ?.value ||
      (this.form.get("reservation")?.get("reservationContacts") as FormArray)?.controls.find((rc) => rc.get("contactType")?.value == "MASTER")?.value
    );
  }

  addParticipant() {
    let oneParticipantEmpty = this.secondaryContactsControls.reduce((acc, control) => {
      return acc || !this.hasClientAssocieted(control.get("id")?.value);
    }, false);
    if (oneParticipantEmpty) {
      toast(tr("Fill in all the already added participants to add a new one"));
      return;
    }

    const newId = (crypto as any).randomUUID();
    let fg = this.fb.group({
      id: [newId],
      name: [""],
      firstName: [""],
      lastName: [""],
      email: [""],
      phoneNumber: [""],
      countryIso: [""],
      contactType: ["SECONDARY"],
      crmContactId: [""],
      manualMarketing: [false],
    });
    (this.form.get("reservation")!.get("reservationContacts") as FormArray).push(fg);
    this.reservationContactToEditId = newId;
  }

  private setContactsArraysWithValues() {
    this.allContactsControls.forEach((control: any) => {
      this.contactsData[control.get("id").value] = {
        contactPrivacy: {},
        contactStatistics: {},
        contactTags: [],
      } as any;
      this.contactDetailOpen[control.get("id").value] = false;
      this.contactsNotMatchingAlerts[control.get("id").value] = {};
    });
    this.allContactsControls.forEach((control: any) => {
      if (!control.get("crmContactId")?.value) return;
      this.contactsService.getv2(control.get("crmContactId").value, this.companyId).subscribe((contact) => {
        if (contact) {
          this.contactsData[control.get("id").value].contactPrivacy = {
            acceptedPrivacyTerms: contact.acceptedPrivacyTerms,
            acceptedMarketing: contact.acceptedMarketing,
            acceptedProfiling: contact.acceptedProfiling,
            manualMarketing: contact.manualMarketing,
            unsubscribed: contact.unsubscribed,
          };
          control.patchValue({
            manualMarketing: contact.manualMarketing,
          });

          if (contact.email !== control.value.email) this.contactsNotMatchingAlerts[control.get("id")?.value][tr("Email")] = contact.email || "-";
          if (contact.firstName !== control.value.firstName && contact.firstName?.replace("_", "") !== control.value.firstName)
            this.contactsNotMatchingAlerts[control.get("id")?.value][tr("First name")] = contact.firstName || "-";
          if (contact.lastName !== control.value.lastName && contact.lastName?.replace("_", "") !== control.value.lastName)
            this.contactsNotMatchingAlerts[control.get("id")?.value][tr("Last name")] = contact.lastName || "-";
          if (contact.phone !== control.value.phoneNumber) this.contactsNotMatchingAlerts[control.get("id")?.value][tr("Phone")] = contact.phone || "-";
          if (contact.countryOfResidenceIso !== control.value.countryIso)
            this.contactsNotMatchingAlerts[control.get("id")?.value][tr("Country of Residence")] = contact.countryOfResidenceIso || "-";

          if (contact.companyName == control.value.firstName) {
            delete this.contactsNotMatchingAlerts[control.get("id")?.value][tr("First name")];
            delete this.contactsNotMatchingAlerts[control.get("id")?.value][tr("Last name")];
          }
        }
      });
      this.statisticsService.get(control.get("crmContactId").value, control.get("email")?.value, this.companyId).subscribe((statistics) => {
        this.contactsData[control.get("id").value].contactStatistics = statistics;
      });
      this.contactsTagsService
        .list({
          contactId: control.get("crmContactId").value,
          wineryId: this.companyId,
        })
        .subscribe((tags) => {
          this.contactsData[control.get("id").value as number | string].contactTags = tags.content;
        });
    });
  }

  private setBasicFormValues() {
    if (this.isTourOperator) {
      this.form
        .get("reservation")!
        .get("manual_origin")!
        .setValue(this.manualOrigins.find((origin) => origin.id === 5));
      this.form.get("reservation")!.get("manual_origin")!.disable();

      const payment1 = this.paymentMethods?.find((pm) => pm.code == "integration");
      this.form.get("reservation")!.get("payment_method")!.setValue(payment1);
      this.form
        .get("reservation")!
        .get("payment2_method")!
        .setValue(payment1?.children?.find((pm) => pm.code == "tour_operator"));
    }

    const r = this.reservation,
      rC = this.reservationToClone,
      e = this.experience;
    if (r && e) {
      this.formPatched = false;
      const visitReason: HostReservationFormOptions.VisitReason | undefined = this.availableVisitReasons.find((tag) => tag.id === r.visitReasonId);
      const manualOrigins = this.manualOrigins.find((origin) => origin.id === r.manualOriginId);

      const pm1Id =
        r.paymentMethodId ?? r.otherData?.paymentMethodId ?? r.optionalData?.paymentMethodId;
      const pm2Id =
        r.payment2MethodId ?? r.otherData?.payment2MethodId ?? r.optionalData?.payment2MethodId;
      const nestedPaymentMethods = this.paymentMethods.reduce(
        (acc, pm) => acc.concat(pm.children ?? []),
        [] as HostReservationFormOptions.PaymentMethod[]
      );
      const payment_method =
        this.paymentMethods.find((pm) => pm.id === pm1Id) ??
        nestedPaymentMethods.find((pm) => pm.id === pm1Id);
      const payment2_method =
        payment_method?.children?.find((pm) => pm.id === pm2Id) ??
        nestedPaymentMethods.find((pm) => pm.id === pm2Id);
      if (payment_method && !this.paymentMethods.some((pm) => pm.id === payment_method!.id)) {
        this.paymentMethods = [...this.paymentMethods, payment_method];
      }

      var reservationToPatch = {
        reservation: {
          id: r.id, //@ts-ignore
          title: e[`title_${locale().locale}`],
          date: parse(r.date!, "yyyy-MM-dd", new Date()),
          contactId: r.contactId,
          time: r.time,
          interval: e.details.duration,
          groupCount: [0],
          lang: r.language ? r.language.iso : undefined,
          origin: r.origin!,
          visit_reason: r.visitReasonId ? visitReason : undefined,
          refer: "",
          ...this.normalizedPaymentAmountFields(r),
          refundedAmount: this.resolveRefundedAmountEuros(r),
          payment_method,
          payment2_method,
          status: ReservationDetail.status(undefined, r.state as any),
          notes: r.notes,
          message: r.message,
          room: r.roomId ? this.getRoom(r.roomId) : undefined,
          employee: r.employeeId ? this.getEmployee(r.employeeId) : undefined,
          manual_origin: r.manualOriginId ? manualOrigins : undefined,
          discount: r.discountTotalCents ? r.discountTotalCents / 100 : 0,
          additional_discount: r.additionalDiscountTotalCents
            ? r.additionalDiscountTotalCents / 100
            : (r.manualDiscountTotalCents || 0) / 100,
          giftAmount:
            (r.otherData?.giftCents || 0) /
            100,
          notify_contact: r.notifyContact,
          invoiceData: r.otherData?.invoiceData,
        } as any,
      };

      if (r.otherData) {
        if (r.otherData.isTourOperator) {
          this.isTourOperator = r.otherData.isTourOperator == true || r.otherData.isTourOperator == "true";
        }

        if (r.otherData.isSales) {
          reservationToPatch.reservation.isSales = r.otherData.isSales == true || r.otherData.isSales == "true";
        }

        if (r.otherData.checkedIn) {
          reservationToPatch.reservation.checkedIn = r.otherData.checkedIn == true || r.otherData.checkedIn == "true";
        }

        if (r.otherData.coupon) {
          reservationToPatch.reservation.coupon_code = r.otherData.coupon;
        }
      }

      this.form.patchValue(reservationToPatch);

      (r.reservationContacts || []).forEach((rc) => {
        let fg = this.fb.group({
          id: [""],
          name: [""],
          firstName: [""],
          lastName: [""],
          email: [""],
          phoneNumber: [""],
          countryIso: [""],
          contactType: [""],
          crmContactId: [""],
          manualMarketing: [false],
        });
        fg.patchValue(rc);
        fg.patchValue({
          crmContactId: !rc.otherData?.crmContactId && rc.contactType === "MASTER" ? r.contactId : rc.otherData?.crmContactId,
        });
        (this.form.get("reservation")!.get("reservationContacts") as FormArray).push(fg);
      });

      this.patchFormPriceLabels(r);
      this.patchFormPriceExtras(r);
      this.formPatched = true;

      // Initialize toggle state based on whether it's a gift or has a coupon
      // Show coupon toggle if it's not a gift (default to true for new reservations)
      this.showCouponToggle = !this.isGift;
      // Update form control disabled states
      this.updateFormControlStates();

      // Trigger change detection for OnPush strategy
      this.cdr.markForCheck();
    } else if (rC && this.isNewReservationFromCalendar) {
      // NEW RESERVATION FROM CALENDAR - precompila solo data e time
      this.formPatched = false;

      this.form.patchValue({
        reservation: {
          date: rC.date,
          time: rC.time,
        },
      });
      this.formPatched = true;
    } else if (rC && e) {
      // CLONE RESERVATION
      this.formPatched = false;

      this.form.patchValue({
        reservation: {
          date: rC.date,
          time: rC.time,
          interval: e.details.duration,
          lang: rC.languageIso,
        },
      });
      this.formPatched = true;
    }

    if (!this.form.get("reservation")!.get("payment2_method")!.value) this.selectPayment2MethodIfThereIsOnlyOne();
    // Note: setContactsArraysWithValues() moved to optional loading to avoid blocking UI
    this.setAutomaticTotal();
  }

  private setFormValues() {
    // Call the basic form values first
    this.setBasicFormValues();
    // Then load contact data in the background (optional)
    this.setContactsArraysWithValues();
  }

  selectPayment2MethodIfThereIsOnlyOne() {
    this.clearCommercialDocumentPaymentHighlights();
    if (this.form.get("reservation")!.get("payment_method")!.value?.children?.length === 1) {
      this.form.get("reservation")!.get("payment2_method")!.setValue(this.form.get("reservation")!.get("payment_method")!.value.children[0]);
    }
  }

  clearCommercialDocumentPaymentHighlights() {
    if (
      !this.missingPaymentModeHighlight &&
      !this.missingPaymentMethodHighlight &&
      !this.missingPaidHighlight
    ) {
      return;
    }
    this.missingPaymentModeHighlight = false;
    this.missingPaymentMethodHighlight = false;
    this.missingPaidHighlight = false;
    this.cdr.markForCheck();
  }

  /**
   * WS-3360: highlight missing payment mode/method/paid (and unsaved changes) and return whether emission must be blocked.
   */
  private markMissingPaymentFieldsForCommercialDocument(): boolean {
    const reservation = this.form?.get("reservation");
    const paymentModeCtrl = reservation?.get("payment_method");
    const paymentMethodCtrl = reservation?.get("payment2_method");
    const paidCtrl = reservation?.get("paid");
    const unsavedPaymentChanges = !!(
      paymentModeCtrl?.dirty ||
      paymentMethodCtrl?.dirty ||
      paidCtrl?.dirty
    );
    const fields = getMissingCommercialDocumentPaymentFields(
      paymentModeCtrl?.value,
      paymentMethodCtrl?.value,
      !!paidCtrl?.value,
      unsavedPaymentChanges
    );
    this.missingPaymentModeHighlight = fields.missingPaymentMode;
    this.missingPaymentMethodHighlight = fields.missingPaymentMethod;
    this.missingPaidHighlight = fields.missingPaid;
    this.cdr.markForCheck();
    return hasCommercialDocumentPaymentBlockers(fields);
  }

  private wrapForceCreateReceiptAction(button: SyncButtonConfig): SyncButtonConfig {
    if (button.id !== "force-create-receipt") {
      return button;
    }
    const originalAction = button.actionObservable;
    return {
      ...button,
      actionObservable: defer(() => {
        if (this.markMissingPaymentFieldsForCommercialDocument()) {
          return of(missingPaymentSyncFailureBody());
        }
        return originalAction.pipe(
          catchError((err) => {
            const body = err?.error ?? { success: false };
            if (isMissingPaymentSyncError(body)) {
              this.markMissingPaymentFieldsForCommercialDocument();
            }
            return of(body);
          }),
          tap((res) => {
            if (isMissingPaymentSyncError(res)) {
              this.markMissingPaymentFieldsForCommercialDocument();
            } else if (isSyncActionSuccess(res)) {
              // WS-4251: backend may delay isSales ~1 min; set optimistically so menu hides and Save persists it
              this.markCommercialDocumentIssuedLocally();
              this.refreshReservationAfterCommercialDocument();
            }
          })
        );
      }),
    };
  }

  /** WS-4251: hide "Genera documento commerciale" via visibleSyncButtons before delayed backend isSales lands. */
  private markCommercialDocumentIssuedLocally() {
    this.form?.get("reservation")?.get("isSales")?.setValue(true, { emitEvent: false });
    if (this.reservation) {
      this.reservation.otherData = {
        ...(this.reservation.otherData || {}),
        isSales: true,
      };
    }
    this.cdr.markForCheck();
  }

  /**
   * After manual commercial-document emission: reload reservation so isSales / sync menu stay in sync
   * (same getV2 pattern used after refund; no full popup re-init).
   */
  private refreshReservationAfterCommercialDocument() {
    if (!this.reservationId) {
      this.getResCashRegisterMetadata();
      return;
    }
    this.reservationDetailService
      .getV2(this.reservationId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (reservation) => {
          this.reservation = reservation;
          const serverIsSales =
            reservation?.otherData?.isSales === true || reservation?.otherData?.isSales === "true";
          const sessionIsSales = this.form?.get("reservation")?.get("isSales")?.value === true;
          if (serverIsSales || sessionIsSales) {
            this.markCommercialDocumentIssuedLocally();
          }
          this.getResCashRegisterMetadata();
          this.cdr.markForCheck();
        },
        error: () => {
          this.getResCashRegisterMetadata();
          this.cdr.markForCheck();
        },
      });
  }

  private generateForm(): FormGroup {
    const form = this.fb.group({
      reservation: this.fb.group({
        id: [""],
        title: [""],
        date: ["", Validators.required],
        time: ["", Validators.required],
        contactId: [""],
        event_date: [""],
        interval: [""],
        groupCount: [0],
        lang: ["", Validators.required],
        origin: [""],
        visit_reason: [""],
        visit_reason_name: [""],
        room: [""],
        employee: [""],
        refer: [""],
        total: [0, Validators.min(0)],
        paid: [false],
        manual_payment_method: [],
        payment_method: [],
        payment2_method: [],
        notes: [""],
        message: [""],
        status: ["", Validators.required],
        manual_origin: [],
        additional_discount: [0, Validators.min(0)],
        notify_contact: [!this.isTourOperator],
        experience_price_labels: this.fb.array([]),
        experience_price_extras: this.fb.array([]),
        due: [0, Validators.min(0)],
        paidAmout: [0, Validators.min(0)],
        refundedAmount: [0, Validators.min(0)],
        total_calculated: [0, Validators.min(0)],
        discount: [0, Validators.min(0)],
        giftAmount: [0],
        isSales: [false],
        checkedIn: [false],
        reservationContacts: this.fb.array([]),
        coupon_code: [""],
        invoiceData: [],
      }),
      clientSearch: [""],
    });

    this.form = form;
    return form;
  }

  // Performance optimization: Methods to handle form control disabled states properly
  private updateFormControlDisabledState(controlName: string, disabled: boolean): void {
    const control = this.form.get(controlName);
    if (control) {
      if (disabled) {
        control.disable();
      } else {
        control.enable();
      }
    }
  }

  private updateReservationFormControlDisabledState(controlName: string, disabled: boolean): void {
    const control = this.form.get("reservation")?.get(controlName);
    if (control) {
      if (disabled) {
        control.disable();
      } else {
        control.enable();
      }
    }
  }

  // Performance optimization: Batch update multiple form controls
  private updateMultipleFormControlsDisabledState(updates: { [key: string]: boolean }): void {
    Object.entries(updates).forEach(([controlName, disabled]) => {
      this.updateReservationFormControlDisabledState(controlName, disabled);
    });
    this.cdr.markForCheck();
  }

  // Performance optimization: Update form control disabled states based on current conditions
  private updateFormControlStates(): void {
    const updates: { [key: string]: boolean } = {};

    // Update paid checkbox based on an active unpaid payment link and edit permissions
    updates['paid'] = this.hasActiveUnpaidPaymentLink() || !this.canEditField('paid_flag');

    // Update isSales checkbox based on edit permissions
    updates['isSales'] = !this.canEditField('fatturato');

    // Update checkedIn checkbox based on edit permissions
    updates['checkedIn'] = !this.canEditField('check_in');

    // Update payment method selects based on payment link and edit permissions
    updates['payment_method'] = this.hasActiveUnpaidPaymentLink() || !this.canEditField('payment_method');
    updates['payment2_method'] = this.hasActiveUnpaidPaymentLink() || !this.canEditField('payment_method');

    // Update other form controls
    updates['event_date'] = !this.canEditField('date');
    updates['lang'] = !this.experienceLanguages?.length || this.isLanguageFieldDisabled;
    updates['manual_origin'] = !this.canEditField('origin');
    updates['visit_reason'] = !this.canEditField('visit_reason');
    updates['room'] = !this.canEditField('room');
    updates['employee'] = !this.canEditField('employee');
    updates['notify_contact'] = !this.canEdit;

    this.updateMultipleFormControlsDisabledState(updates);
  }

  // Performance optimization: TrackBy functions for ngFor loops
  trackByPaymentMethod(index: number, item: any): any {
    return item?.id || index;
  }

  trackByRoom(index: number, item: any): any {
    return item?.id || index;
  }

  trackByEmployee(index: number, item: any): any {
    return item?.id || index;
  }

  trackByLanguage(index: number, item: any): any {
    return item?.iso || index;
  }

  trackByManualOrigin(index: number, item: any): any {
    return item?.id || index;
  }

  trackByVisitReason(index: number, item: any): any {
    return item?.id || index;
  }

  trackByContact(index: number, item: any): any {
    return item?.id || index;
  }

  trackByCoupon(index: number, item: any): any {
    return item?.id || index;
  }

  private patchReservationFromForm(): ReservationDTO {
    const r = this.form.get("reservation")!;

    let date = r.get("date")!.value;
    if (!moment.isMoment(date)) date = moment(date);
    let time = r.get("time")!.value;
    if (time.split(":").length < 3) time = time + ":00";
    // OTHER DATA JSON
    var otherData = {} as any;
    if (this.reservation?.optionalData) {
      otherData = this.reservation?.optionalData;
    }

    if (r.get("isSales")!.value !== undefined && r.get("isSales")!.value !== null) {
      otherData.isSales = r.get("isSales")!.value;
    }

    if (r.get("checkedIn")!.value !== undefined && r.get("checkedIn")!.value !== null) {
      otherData.checkedIn = r.get("checkedIn")!.value;
    }

    if (r.get("paid")!.value !== undefined && r.get("paid")!.value !== null) {
      otherData.paid = r.get("paid")!.value;
    }

    if (r.get("coupon_code")!.value !== undefined && r.get("coupon_code")!.value !== null) {
      otherData.coupon = r.get("coupon_code")!.value;
    }

    if (this.isTourOperator) {
      otherData.isTourOperator = this.isTourOperator;
    }

    if (r.get("invoiceData")!.value !== undefined && r.get("invoiceData")!.value !== null) {
      otherData.invoiceData = r.get("invoiceData")!.value;
    }

    var oldState = r.get("status")!.value.type || "confirmed";
    var newState = oldState;
    if (this.isDraft) {
      newState = "draft";
    } else {
      if (oldState == "draft" && !this.isDraft) {
        newState = "confirmed";
      }
    }

    return {
      id: r.get("id")!.value,
      state: newState,
      guestCountTotal: this.getTotalCount(),
      guestCount01: r.get("experience_price_labels")?.value[0]?.quantity || 0,
      experiencePriceLabels: this.cleanAndFixLabels(r.get("experience_price_labels")!.value, "LABEL") || [],
      experiencePriceExtras: this.cleanAndFixLabels(r.get("experience_price_extras")!.value, "EXTRA") || [],
      languageIso: r.get("lang")!.value,
      experienceId: this.experience?.id,
      reservationContacts: r.get("reservationContacts")?.value?.map((c: any) => {
        if (!c.otherData) c.otherData = {};
        c.otherData.crmContactId = c.crmContactId;
        c.otherData.privacy = { manualMarketing: c.manualMarketing };
        if (c.contactType === "MASTER" && this.isTourOperator) {
          c.otherData.tourOperator = true;
        }
        if (typeof c.id === "string" && c.id.includes("-")) {
          delete c.id;
        } else {
          try {
            c.id = parseInt(c.id);
          } catch {
            delete c.id;
          }
        }
        return c;
      }),
      contactId: this.masterContactControl?.get("crmContactId")?.value,
      date: date.format("yyyy-MM-DD"),
      time: time,
      netTotalCents: Math.round(r.get("total")!.value * 100),
      grossTotalCents: Math.round((Number(r.get("total")!.value) + Number(r.get("additional_discount")!.value)) * 100),
      discountTotalCents: Math.round(r.get("discount")!.value * 100),
      additionalDiscountTotalCents: Math.round(r.get("additional_discount")!.value * 100),
      manualDiscountTotalCents: Math.round(r.get("additional_discount")!.value * 100),
      paidTotalCents: Math.round(r.get("paidAmout")!.value * 100),
      dueTotalCents: Math.round(r.get("due")!.value * 100),
      paymentCurrency: this.reservation?.paymentCurrency || "EUR",
      origin: r.get("origin")!.value,
      wineryChannelId: undefined,
      wineryChannelTypeId: undefined,
      wineryId: this.companyId,
      message: this.reservation?.message,
      notes: r.get("notes")!.value,
      notifyContact: r.get("notify_contact")!.value,
      paid: r.get("paid")!.value || false,
      giftId: this.reservation?.giftId,
      roomId: r.get("room")!.value?.id || undefined,
      employeeId: r.get("employee")!.value?.id || undefined,
      paymentMethodId: r.get("payment_method")?.value?.id || undefined,
      payment2MethodId: r.get("payment2_method")?.value?.id || undefined,
      manualOriginId: r.get("manual_origin")?.value?.id || undefined,
      visitReasonId: r.get("visit_reason")!.value?.id,
      paymentId: this.reservation?.paymentId,
      type: this.reservation?.type,
      createdAt: this.reservation?.createdAt,
      updatedAt: this.reservation?.updatedAt,
      optionalData: otherData,
    };
  }

  cleanAndFixLabels(labels: any[], type: "LABEL" | "EXTRA" = "LABEL") {
    let pricesArray = this.experience?.prices?.filter((price) => this.experiencePriceRowMatchesKind(price, type)) || [];
    return labels.map((label) => {
      var obj = {
        ...label,
        price_cents: pricesArray.find((x) => x.position == label.position)?.priceCents,
        price_currency: pricesArray.find((x) => x.position == label.position)?.priceCurrency,
      };

      if (!obj.id || obj.id == "") {
        delete obj.id;
      }

      const priceRow = pricesArray.find((x) => x.position == label.position);
      const merged = {
        ...langMapFromPriceRow(priceRow),
        ...langMapFromTranslationsBlob(label.title_translations),
      };
      obj.title_translations = {
        en: englishSlotText(merged, this.lang),
        it: captionFromLangMap(merged, priceCaptionPickOrder(this.lang, "it")),
        de: captionFromLangMap(merged, priceCaptionPickOrder(this.lang, "de")),
      };

      delete obj.updated_at;
      delete obj.created_at;
      obj.experienceId = this.experience?.id;

      return obj;
    });
  }

  setAutomaticTotal() {
    const form = this.form;

    const couponCodeCtrl = form.get("reservation")!.get("coupon_code")!;
    couponCodeCtrl.valueChanges.subscribe((couponCode) => {
      let coupon = this.availableCoupons.find((c) => c.code === couponCode);
      this.couponSelected(coupon);
    });

    const discountCtrl = form.get("reservation")?.get("additional_discount")!;
    discountCtrl.valueChanges.subscribe((discount) => {
      this.updateTotal("additional_discount", discount);
    });

    const couponCtrl = form.get("reservation")?.get("discount")!;
    couponCtrl.valueChanges.subscribe((discount) => {
      this.updateTotal("discount", discount);
    });

    const totalCtrl = form.get("reservation")!.get("total")!;
    totalCtrl.valueChanges.subscribe((total) => {
      this.updateTotal("total", total);
    });

    const dueCtrl = form.get("reservation")!.get("due")!;
    dueCtrl.valueChanges.subscribe((due) => {
      this.updateTotal("due", due);
    });

    const paidCtrl = form.get("reservation")!.get("paidAmout")!;
    paidCtrl.valueChanges.subscribe((paidAmout) => {
      this.updateTotal("paidAmout", paidAmout);
    });

    const priceLabelCtrl = form.get("reservation")!.get("experience_price_labels")!;
    priceLabelCtrl.valueChanges.subscribe((priceLabel) => {
      this.updateTotal("experience_price_labels", priceLabel);
    });

    const priceExtraCtrl = form.get("reservation")!.get("experience_price_extras")!;
    priceExtraCtrl.valueChanges.subscribe((priceExtra) => {
      this.updateTotal("experience_price_extras", priceExtra);
    });

    this.updateTotal("total", "", true);

    return form;
  }

  private isUpdatingTotal = false;

  updateTotal(
    changedValue: "discount" | "additional_discount" | "experience_price_labels" | "experience_price_extras" | "due" | "total" | "paidAmout",
    newValue: any,
    initial: boolean = false
  ) {
    if (!this.experience) return;

    // Prevent infinite recursion, but allow initial calls
    if (this.isUpdatingTotal && !initial) return;

    // For non-initial calls, set the flag
    if (!initial) {
      this.isUpdatingTotal = true;
    }

    try {
      // check if the value is an array not empty a number and > 0
      newValue = newValue
        .toString()
        .replace(/[^\d.-]/g, "")
        .trim()
        .slice(0, 10);
      if (newValue.length) {
        if (newValue.length == 0) newValue = 0;
      } else {
        if (isNaN(newValue) || newValue <= 0) newValue = 0;
      }

      const form = this.form;

      function getCleanValueFrom(form: FormGroup, fieldName: any) {
        try {
          if (!form.get("reservation")!.get(fieldName)) {
            return 0;
          }
          const value = form.get("reservation")!.get(fieldName)!.value || 0;
          return value;
        } catch (err) {
          //no
        }
        return 0;
      }
      // get the total value
      const total = getCleanValueFrom(form, "total");

      let additionalDiscount = getCleanValueFrom(form, "additional_discount");
      if (changedValue === "additional_discount") {
        additionalDiscount = newValue;
      }

      // arrays of price labels and price extras
      const priceLabels = this.form.get("reservation")!.get("experience_price_labels")!.value;
      const priceExtras = this.form.get("reservation")!.get("experience_price_extras")!.value;
      const totalLabels =
        (priceLabels &&
          priceLabels.map((e: { quantity: number; price_cents: number }) => e.quantity * e.price_cents).reduce((x: any, y: any) => x + y, 0) / 100) ||
        0;

      const totalExtras =
        (priceExtras &&
          priceExtras.map((e: { quantity: number; price_cents: number }) => e.quantity * e.price_cents).reduce((x: any, y: any) => x + y, 0) / 100) ||
        0;

      // calculate the total value
      let totalCalc = (((totalLabels as number) + totalExtras) as number) || 0;
      // get the discount value
      const couponCode = form.get("reservation")!.get("coupon_code")!;
      let discount = 0;
      if (couponCode.value) discount = this.calculateDiscount(couponCode.value, totalCalc);

      let giftAmount = getCleanValueFrom(form, "giftAmount");

      let totalWithDiscountCalc =
        totalCalc * 100 -
          (discount + parseFloat(additionalDiscount ?? "0") + giftAmount) * 100 || 0;
      let totalWithDiscount = Math.max(0, totalWithDiscountCalc / 100); // multiplying and dividing by 100 to avoid floating point issues
      if (changedValue === "total") {
        totalWithDiscount = newValue;
      }

      form.get("reservation")!.get("total_calculated")!.setValue(totalCalc);

      if (initial) {
        return;
      }

      if (changedValue !== "total" && changedValue !== "due" && changedValue !== "paidAmout") {
        form.get("reservation")!.get("total")!.setValue(totalWithDiscount);
        this.updateDue(totalWithDiscount, changedValue, newValue);
      } else {
        this.updateDue(form.get("reservation")!.get("total")!.value, changedValue, newValue);
      }
    } finally {
      // Only reset the flag if we're not in initial mode
      if (!initial) {
        this.isUpdatingTotal = false;
      }
    }
  }

  private isUpdatingDue = false;

  updateDue(
    totalCalc: number | 0,
    changedValue: "discount" | "additional_discount" | "experience_price_labels" | "experience_price_extras" | "due" | "total" | "paidAmout",
    newValue: any
  ) {
    // Prevent infinite recursion
    if (this.isUpdatingDue) return;
    this.isUpdatingDue = true;

    try {
      if (newValue) {
        newValue = newValue
          .toString()
          .replace(/[^\d.-]/g, "")
          .trim()
          .slice(0, 10);
      }
      if (totalCalc == null || totalCalc == undefined || totalCalc < 0) {
        return;
      }
      const form = this.form;
      function getCleanValueFrom(form: FormGroup, fieldName: any) {
        try {
          if (!form.get("reservation")!.get(fieldName)) {
            return 0;
          }
          const value = form.get("reservation")!.get(fieldName)!.value || 0;
          return value;
        } catch (err) {
          //no
        }
        return 0;
      }
      // get the paid value
      let paid = getCleanValueFrom(form, "paidAmout");
      if (changedValue === "paidAmout") {
        paid = newValue;
      }

      const priceLabels = this.form.get("reservation")!.get("experience_price_labels")!.value;
      const priceExtras = this.form.get("reservation")!.get("experience_price_extras")!.value;
      const nLabels = priceLabels?.map((e: { quantity: number }) => e.quantity).reduce((x: any, y: any) => x + y, 0) / 100 || 0;
      const nExtras = priceExtras?.map((e: { quantity: number }) => e.quantity).reduce((x: any, y: any) => x + y, 0) / 100 || 0;

      // calculate the due value
      let dueCalc = 0;
      if (changedValue === "due") {
        dueCalc = newValue;
      } else {
        dueCalc = (this.reservation?.state == "rejected" || this.reservation?.state == "revoked" ? 0 : totalCalc) - paid;
        form.get("reservation")!.get("due")!.setValue(dueCalc);
        if (dueCalc > 0 || nLabels + nExtras == 0) {
          form.get("reservation")!.get("paid")!.setValue(false);
        } else {
          form.get("reservation")!.get("paid")!.setValue(true);
        }
      }

      let paidCalc = 0;
      if (changedValue === "paidAmout") {
        paidCalc = newValue;
      } else {
        paidCalc = totalCalc - dueCalc;
        form.get("reservation")!.get("paidAmout")!.setValue(paidCalc);
      }
    } finally {
      this.isUpdatingDue = false;
    }
  }

  logEventDates(data: any) {
    console.log("Event Dates: ", data);
    console.log("Event Dates Form Value: ", this.form.get("reservation")!.get("event_date")!.value);
  }

  couponSelected(coupon: Host.Coupon.Data | undefined) {
    let discount = coupon
      ? coupon.discount_type == "absolute"
        ? coupon.discount_cents / 100
        : Math.floor(coupon.discount_percent * this.form.get("reservation")!.get("total_calculated")!.value) / 100
      : 0;

    this.form.get("reservation")!.get("discount")!.setValue(discount);
  }

  calculateDiscount(couponCode: string, totalCalc: number) {
    if (this.availableCoupons.length == 0) return this.form.get("reservation")!.get("discount")!.value || 0;
    let coupon = this.availableCoupons.find((c) => c.code === couponCode);
    let discount = coupon ? (coupon.discount_type == "absolute" ? coupon.discount_cents / 100 : Math.floor(coupon.discount_percent * totalCalc) / 100) : 0;
    this.form.get("reservation")!.get("discount")!.setValue(discount);
    return discount;
  }

  calculateDiscountValue() {
    if( this.form.get("reservation")!.get("discount")){
      return this.form.get("reservation")!.get("discount")!.value || 0;
    }
    const couponCode = this.form.get("reservation")!.get("coupon_code")!;
    let discount = 0;
    try {
      if (couponCode.value) {
        // arrays of price labels and price extras
        const priceLabels = this.form.get("reservation")!.get("experience_price_labels")!.value;
        const priceExtras = this.form.get("reservation")!.get("experience_price_extras")!.value;
        const totalLabels =
          (priceLabels &&
            priceLabels.map((e: { quantity: number; price_cents: number }) => e.quantity * e.price_cents).reduce((x: any, y: any) => x + y, 0) / 100) ||
          0;

        const totalExtras =
          (priceExtras &&
            priceExtras.map((e: { quantity: number; price_cents: number }) => e.quantity * e.price_cents).reduce((x: any, y: any) => x + y, 0) / 100) ||
          0;

        // calculate the total value
        let totalCalc = (((totalLabels as number) + totalExtras) as number) || 0;
        // get the discount value

        let coupon = this.availableCoupons.find((c) => c.code === couponCode.value);
        discount = coupon ? (coupon.discount_type == "absolute" ? coupon.discount_cents / 100 : Math.floor(coupon.discount_percent * totalCalc) / 100) : 0;
      }
    } catch (err) {
      console.error("Error calculating discount:", err);
      discount = 0;
    }

    this.form.get("reservation")!.get("discount")!.setValue(discount);
    return discount;
  }

  getInputValue(event: Event) {
    return (event.target as HTMLInputElement).value.replace(" €", "");
  }

  private listenerForFetchAvailability() {
    const r = this.form.get("reservation");
    if (!r) return;
    r?.get("date")
      ?.valueChanges.pipe(debounce(() => timer(500)))
      .subscribe((day) => {
        const experienceId = this.experience?.id;
        const time = r.get("time")?.value;

        if ((!this.reservation || this.reservation?.type === "manual") && day && experienceId && time) {
          observe(
            this.experienceAvailabilityService.haveAvailability({
              experienceId,
              time,
              date: day,
            })
          ).subscribe((e) => (this.hasAnyAvailabilityForDateDay = e));
        }
      });

    r?.get("time")
      ?.valueChanges.pipe(debounce(() => timer(500)))
      .subscribe((time) => {
        const experienceId = this.experience?.id;
        const day = r.get("date")?.value;

        if ((!this.reservation || this.reservation?.type === "manual") && time && experienceId && day) {
          observe(
            this.experienceAvailabilityService.haveAvailability({
              experienceId,
              time,
              date: day,
            })
          ).subscribe((e) => (this.hasAnyAvailabilityForDateDay = e));
        }

      });

    r?.get("event_date")
      ?.valueChanges.pipe(debounce(() => timer(2500)))
      .subscribe((eventDate) => {
        if (eventDate && this.experienceType === "event") {
          const date = moment(eventDate).format("YYYY-MM-DD");
          const time = moment(eventDate).format("HH:mm");
          const experienceId = this.experience?.id;

          this.form.get("reservation")?.patchValue({
            date,
            time,
          });

          if ((!this.reservation || this.reservation?.type === "manual") && date && time && experienceId) {
            observe(
              this.experienceAvailabilityService.haveAvailability({
                experienceId,
                time,
                date: date,
              })
            ).subscribe((e) => (this.hasAnyAvailabilityForDateDay = e));
          }
        }
      });
  }

  getBackButtonMessage(currentState: string | undefined, selectedState: string) {
    if (this.isManualReservation) {
      if (this.hasAnyAvailabilityForDateDay && this.shouldAskForSlotClosing) {
        return this.getIgnoreBlockButton();
      }
    } else if (currentState === "waiting" && selectedState === "confirmed" && this.shouldAskForSlotClosing) {
      return this.getIgnoreBlockButton();
    }
    return tr("Back");
  }

  isPaid(): boolean {
    return this.remainingDueCents() <= 0 && (this.reservation?.paid === true || this.paymentLinkStatus() === "paid");
  }

  isPaymentLinkExpired(): boolean {
    if (!this.paymentLinkData || this.isPaid()) {
      return false;
    }
    return this.paymentLinkData.linkStatus === 'expired';
  }

  hasBlockingPaymentLink(): boolean {
    return this.hasActiveUnpaidPaymentLink();
  }

  remainingDueCents(): number {
    const group = this.form?.get("reservation");
    const totalRaw = Number(group?.get("total")?.value);
    const paidRaw = Number(group?.get("paidAmout")?.value);
    const total = Number.isFinite(totalRaw)
      ? totalRaw
      : (this.reservation?.netTotalCents || 0) / 100;
    const paid = Number.isFinite(paidRaw)
      ? paidRaw
      : (this.reservation?.paidTotalCents || 0) / 100;
    const paidCapped = total > 0 ? Math.min(Math.max(paid, 0), total) : Math.max(paid, 0);
    return Math.max(0, Math.round((total - paidCapped) * 100));
  }

  showGeneratePaymentLink(): boolean {
    return this.remainingDueCents() > 0 && !this.hasActiveUnpaidPaymentLink();
  }

  showPaymentLinkAction(): boolean {
    return !!this.paymentLinkData && !this.showGeneratePaymentLink();
  }

  hasActiveUnpaidPaymentLink(): boolean {
    if (!this.paymentLinkData) {
      return false;
    }
    const status = this.paymentLinkStatus();
    if (status === "paid" || status === "expired") {
      return false;
    }
    return this.remainingDueCents() > 0;
  }

  private paymentLinkStatus(link: PaymentLink | null = this.paymentLinkData): string {
    if (!link) {
      return "";
    }
    if (link.linkStatus) {
      return link.linkStatus;
    }
    if (link.expiresAt && Date.parse(link.expiresAt) <= Date.now()) {
      return "expired";
    }
    return link.lastSentTo ? "sent" : "generated";
  }

  private pickPaymentLinkForReservation(links: PaymentLink[] | undefined | null): PaymentLink | null {
    if (!links?.length) {
      return null;
    }
    const sorted = [...links].sort(
        (a, b) => Date.parse(b.createdAt || "") - Date.parse(a.createdAt || "")
    );
    return sorted.find((link) => !link.deletedAt) || sorted[0] || null;
  }


  capitalize(x: string) {
    return _.capitalize(x);
  }

  openPaymentPage() {
    this.loading = true;
    observe(
      !!this.paymentLinkData
        ? of(`${environment.values["stripe-dashboard-url"]}/payments/${this.paymentLinkData?.paymentIntentExternalId}`)
        : this.paymentMethodsService.getPaymentPageUrl(this.reservation!.id!)
    ).subscribe((url) => {
      if (url && url.length > 0) {
        window.open(url, "_blank");
      } else {
        toast(tr("No payment data available"));
      }
      this.loading = false;
    });
  }
  openWSPaymentPage() {
    this.loading = true;
    observe(
      !!this.paymentLinkData
        ? of(`${environment.values["stripe-dashboard-url"]}/payments/${this.paymentLinkData?.paymentIntentExternalId}`)
        : this.paymentMethodsService.getPaymentPageUrl(this.reservation!.id!)
    ).subscribe((url) => {
      if (url && url.length > 0) {
        window.open(url, "_blank");
      } else {
        toast(tr("No payment data available"));
      }
      this.loading = false;
    });
  }

  /** Shows when reservation has WSPayments (dwspay) payment, not nexi, paid online, paid, and a payment link exists. */
  mustShowWSPaymentIcon(): boolean {
    return this.isDwspayPayment && this.isPaid() && !!this.paymentLinkData && !!this.paymentLinkData.url;
  }

  openDwspayPaymentDetailDialog(): void {
    const payment = this.paymentForDialog;
    const company = this.companyInt;
    const paymentIntentId = payment?.externalId?.trim();
    if (!paymentIntentId || !company?.id) {
      toast(tr('No payment data available'));
      return;
    }
    this.paymentsPaymentDetailDialogService.open(
      company,
      paymentIntentId,
      (updatedPayment) => this.refreshReservationAfterPaymentChange(updatedPayment),
      this.reservationId,
    );
  }

  private refreshReservationAfterPaymentChange(payment?: WsPaymentItem): void {
    if (!this.reservationId) {
      return;
    }

    this.reservationDetailService.getV2(this.reservationId).pipe(take(1)).subscribe((fresh) => {
      let refundedTotalCents =
        fresh.refundedTotalCents ??
        (fresh as any).otherData?.refundedTotalCents ??
        0;
      if (refundedTotalCents <= 0 && payment?.amountRefundedCents) {
        refundedTotalCents = payment.amountRefundedCents;
      }

      const refundedAt =
        fresh.refundedAt ??
        (fresh as any).otherData?.refundedAt ??
        (payment?.refunds?.[0]?.created
          ? new Date(payment.refunds[0].created * 1000).toISOString()
          : undefined);

      if (refundedAt) {
        this.refundDate = typeof refundedAt === 'string' ? parseISO(refundedAt) : new Date(refundedAt);
      }
      const totalCents = fresh.netTotalCents ?? 0;
      if (totalCents > 0 && refundedTotalCents >= totalCents) {
        this.paymentRefunded = true;
      }

      if (this.reservation) {
        this.reservation.refundedTotalCents = refundedTotalCents;
        if (refundedAt) {
          this.reservation.refundedAt = refundedAt as any;
          this.reservation.otherData = {
            ...(this.reservation.otherData ?? {}),
            refundedTotalCents,
            refundedAt,
          };
        }
      } else {
        this.reservation = fresh;
        this.reservation.language = this.languages.find(
          (e) => e.iso == fresh.languageIso
        );
      }

      this.checkPaymentRefunded();
      this.patchRefundedAmount();
      if (this.reservation?.id) {
        this.loadDwspayPaymentRecord(this.reservation.id);
      }
      this.reservationUpdated.emit(this.reservation);
      this.cdr.markForCheck();
    });
  }

  formatString(template: string, ...values: any[]): string {
    return template.replace(/{(\d+)}/g, (match, index) => {
      const adjustedIndex = parseInt(index) - 1;
      const value = values[adjustedIndex];
      return value !== undefined ? value : match;
    });
  }

  generateMessage(): string {
    var messageOrig = tr("Contact_USER");
    var res = this.reservation;
    var name = this.reservation?.reservationMasterContact?.name;
    var email = this.reservation?.reservationMasterContact?.email;
    var phone = this.reservation?.reservationMasterContact?.phoneNumber;
    var date = this.reservation?.date;
    const inputDate = new Date(date!);
    // Format the date in "dd-mm-yyyy" format
    const outputDateStr = `${inputDate.getDate().toString().padStart(2, "0")}-${(inputDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${inputDate.getFullYear()}`;
    var time = this.reservation?.time;
    var reservationId = this.reservation?.id;
    var cantina = this.companyInt?.name;
    var experience = this.experienceTitleForLocale();
    return this.formatString(messageOrig, name, outputDateStr, time, cantina, reservationId, experience);
  }

  generateSubject(): string {
    var messageOrig = tr("Contact_USER_subj");
    var res = this.reservation;
    var name = this.reservation?.reservationMasterContact?.name;
    var email = this.reservation?.reservationMasterContact?.email;
    var phone = this.reservation?.reservationMasterContact?.phoneNumber;
    var reservationId = this.reservation?.id;
    var date = this.reservation?.date;
    const inputDate = new Date(date!);
    // Format the date in "dd-mm-yyyy" format
    const outputDateStr = `${inputDate.getDate().toString().padStart(2, "0")}-${(inputDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${inputDate.getFullYear()}`;
    var time = this.reservation?.time;
    var experience = this.experienceTitleForLocale();
    var cantina = this.companyInt?.name;
    return this.formatString(messageOrig, name, outputDateStr, time, cantina, reservationId, experience);
  }

  sendWhatsApp() {
    var message = this.generateMessage();
    var phone = this.reservation?.reservationMasterContact?.phoneNumber?.replace("+", "").replace(" ", "");
    const url = "https://wa.me/" + phone + "/?text=" + encodeURIComponent(message); // Replace with the URL you want to open
    window.open(url, "_blank");
  }

  sendMailTo() {
    var message = this.generateMessage();
    var subject = this.generateSubject();
    var email = this.reservation?.reservationMasterContact?.email;
    const url = "mailto:" + email + "?subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(message); // Replace with the URL you want to open
    window.open(url, "_blank");
  }

  getTotalCount(): number {
    const r = this.form.get("reservation")!;
    var qty = 0;

    const priceLabels = this.form.get("reservation")!.get("experience_price_labels")!.value;

    const totalLabels =
      (priceLabels && priceLabels.map((e: { quantity: number; price_cents: number }) => e.quantity).reduce((x: any, y: any) => x + y, 0)) || 0;

    qty += totalLabels as number;

    return qty;
  }

  //toggleTooltip(
  //  event: MouseEvent,
  //  isEntering: boolean,
  //  element: InfoIconHoverableComponent
  //): void {
  //  if (isEntering) {
  //    element.onMouseOverInternal(event);
  //  } else {
  //    element.onMouseOut(event);
  //  }
  //}

  isTotalWarning() {
    // multiplying by 100 to avoid floating point problems
    return (
      parseFloat(this.form.get("reservation")?.get("total")?.value) * 100 !=
      Math.max(
        0,
        this.form.get("reservation")?.get("total_calculated")?.value * 100 -
          parseFloat(this.form.get("reservation")?.get("discount")?.value) * 100 -
          parseFloat(this.form.get("reservation")?.get("additional_discount")?.value || 0) * 100
        // - (parseFloat(this.form.get("reservation")?.get("giftAmount")?.value || 0) * 100) //already added to total
      )
    );
  }

  additionalDiscountChanged() {
    const reservationGroup = this.form.get("reservation");
    if (!reservationGroup) {
      return;
    }

    const totalCalculated = Number(reservationGroup.get("total_calculated")?.value) || 0;
    const discount = Number(reservationGroup.get("discount")?.value) || 0;
    const additionalDiscount = Number(reservationGroup.get("additional_discount")?.value) || 0;
    const giftAmount = Number(reservationGroup.get("giftAmount")?.value) || 0;

    const newTotal = totalCalculated - discount - additionalDiscount - giftAmount;
    reservationGroup.get("total")?.setValue(newTotal);
  }

  reservationDateChanged(event: MatDatepickerInputEvent<Moment>) {
    if (event.value && moment(event.value).toDate() < new Date()) {
      this.form.get("reservation")?.get("notify_contact")?.setValue(false);
    } else {
      this.form.get("reservation")?.get("notify_contact")?.setValue(true);
    }
  }

  getOrigin(origin: any): any {
    if (typeof origin !== "string" || !origin) {
      return "";
    }
    var originFormatted = origin.replace("https://", "").replace("http://", "").replace("www.", "").replace(/\:\d+/g, "").toLowerCase();
    if (origin.toLocaleLowerCase().indexOf("manual") > -1 || "Wine Suite".indexOf(origin) > -1) {
      originFormatted = tr("Manual Reservation");
    }
    originFormatted = tr(originFormatted);
    return originFormatted ? originFormatted : tr(origin);
  }

  private experienceTitleForLocale(): string {
    const currentLang = normalizeLangIso(locale().locale);
    return (
      this.experience?.details?.titles?.find(
        (t) =>
          t?.languageIsoCode != null &&
          normalizeLangIso(String(t.languageIsoCode)) === currentLang
      )?.text || ""
    );
  }

  async generatePaymentLinkClicked(event: MouseEvent) {
    event.stopPropagation();
    const dueCents = this.remainingDueCents();
    if (dueCents <= 0) {
      toast(tr("Unable to generate payment link: no amount due"));
      return;
    }
    let sure = await confirm.yesno(
      tr("Are you sure you want to generate a payment link for {}?").replace(
        "{}",
        new CurrencyPipe(this.lang || "en").transform(dueCents / 100, "EUR", "symbol") || ""
      ),
      tr("Confirm!"),
      tr("Cancel")
    );
    if (!sure) return;

    // Determine the correct wineryId: prioritize reservation's wineryId
    const wineryId = this.reservation?.wineryId || this.companyId;
    if (!wineryId) {
      toast(tr("Unable to generate payment link: winery information is missing"));
      return;
    }

    this.isCreatingPaymentLink = true;
    this.wsPaymentsService
      .createPaymentLink(
        [
          {
            quantity: 1,
            netTotalCents: dueCents,
            vatPercent: 0,
            entityType: "reservation",
            entityId: this.reservation?.id,
          },
        ],
        this.reservation?.contactId,
        wineryId,
        this.reservation?.languageIso,
        this.reservation?.paymentCurrency,
      )
      .subscribe(
        ([pl, _]) => {
          this.paymentLinkData = pl;
          this.updateFormControlStates();
          this.openPaymentLinkDialog();
          this.isCreatingPaymentLink = false;
          this.cdr.markForCheck();
        },
        (err) => {
          toast(tr("An error occurred. Try later"));
          this.isCreatingPaymentLink = false;
        }
      );
  }

  generateWineLensLinkClicked() {
    const wineLensEndpoint = environment.values.winelens_url;

    if (!wineLensEndpoint) {
      toast(tr("WineLens not configured for this environment"));
      return;
    }

    this.dlg.open(QrcodeOrSendLinkDialogComponent, {
      data: {
        title: tr("Wine Lens"),
        url: `${wineLensEndpoint}/register?wineryId=${this.companyInt?.id}&reservationId=${this.reservation?.id}`,
        email: this.reservation?.reservationMasterContact?.email,
        phone: this.reservation?.reservationMasterContact?.phoneNumber,
      },
      width: "600px",
      height: "550px",
    });
  }
  openPaymentLinkDialog() {
    this.dlg.open(PaymentLinkDialogComponent, {
      data: {
        reservation: this.reservation,
        experience: this.experience,
        companyInt: this.companyInt,
        paymentLink: this.paymentLinkData,
        isPaid: this.remainingDueCents() <= 0 || this.paymentLinkStatus() === "paid",
        wineryId: this.companyInt?.id,
        amountDueCents: this.remainingDueCents(),
        canRegenerate: this.canEdit,
      },
      width: "600px",
      minHeight: "370px",
    }).afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
      if (result?.paymentLink) {
        this.paymentLinkData = result.paymentLink;
      }
      if (this.paymentLinkData) {
        this.refreshReservationPaymentState();
      }
      this.updateFormControlStates();
      this.cdr.markForCheck();
    });
  }

  private refreshReservationPaymentState(): void {
    if (!this.reservationId || this.refreshingPaymentState || !this.paymentLinkData) {
      return;
    }

    this.refreshingPaymentState = true;
    forkJoin({
      reservation: this.reservationDetailService.getV2(this.reservationId),
      paymentLinks: this.wsPaymentsService.getPaymentLink({ reservationId: this.reservationId }).pipe(
        catchError(() => of({ content: [] as PaymentLink[] }))
      ),
    })
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.refreshingPaymentState = false;
        })
      )
      .subscribe({
        next: ({ reservation, paymentLinks }) => {
          this.reservation = reservation;
          this.reservation.language = this.languages?.find((e) => e.iso == reservation.languageIso);
          this.paymentLinkData = this.pickPaymentLinkForReservation(paymentLinks.content);
          this.patchPaymentTotalsFromReservation(reservation);
          this.checkPaymentRefunded();
          this.updateFormControlStates();
          this.cdr.markForCheck();
        },
        error: () => {
          this.cdr.markForCheck();
        },
      });
  }

  private patchPaymentTotalsFromReservation(r: ReservationDTO): void {
    const group = this.form?.get("reservation");
    if (!group) {
      return;
    }

    const pm1Id = r.paymentMethodId ?? r.otherData?.paymentMethodId ?? r.optionalData?.paymentMethodId;
    const pm2Id = r.payment2MethodId ?? r.otherData?.payment2MethodId ?? r.optionalData?.payment2MethodId;
    const nestedPaymentMethods = (this.paymentMethods || []).reduce(
      (acc, pm) => acc.concat(pm.children ?? []),
      [] as HostReservationFormOptions.PaymentMethod[]
    );
    const payment_method =
      this.paymentMethods?.find((pm) => pm.id === pm1Id) ?? nestedPaymentMethods.find((pm) => pm.id === pm1Id);
    const payment2_method =
      payment_method?.children?.find((pm) => pm.id === pm2Id) ?? nestedPaymentMethods.find((pm) => pm.id === pm2Id);

    const amounts = this.normalizedPaymentAmountFields(r);

    group.patchValue(
      {
        total: amounts.total,
        due: amounts.due,
        paid: amounts.paid,
        paidAmout: amounts.paidAmout,
        ...(payment_method ? { payment_method } : {}),
        ...(payment2_method ? { payment2_method } : {}),
      },
      { emitEvent: false }
    );
  }

  private normalizedPaymentAmountFields(r: ReservationDTO): {
    total: number;
    due: number;
    paid: boolean;
    paidAmout: number;
  } {
    const total = (r.netTotalCents || 0) / 100;
    let paidAmount = (r.paidTotalCents || 0) / 100;
    if (total > 0 && paidAmount > total) {
      paidAmount = total;
    }
    const due = Math.max(0, total - paidAmount);
    return {
      total,
      due,
      paid: due <= 0 || !!r.paid || (r.netTotalCents == 0 && !!r.otherData?.giftCents),
      paidAmout: paidAmount,
    };
  }

  openAvailabilityAutomationDialog() {
    this.dlg
      .open(AvailabilityAutomationDialogComponent, {
        data: {
          isAvailabilityBlock: this.isAvailabilityBlock,
          isLanguageBlock: this.isLanguageBlock,
          hasEnabledAutomations: this.hasEnabledAutomations,
        },
        width: "90vw",
        maxWidth: "400px",
        minWidth: "280px",
        maxHeight: "90vh",
        autoFocus: false,
        restoreFocus: false,
      })
      .afterClosed()
      .subscribe(async (result) => {
        const multiple = result?.length > 1;
        if (multiple) {
          const shouldDoAllTheStuff = await confirm.yesno(this.getSlotsPrincipalMessage("multiple", result), tr("Yes"), tr("No"));
          if (!shouldDoAllTheStuff) return;
        }
        forkJoin(
          ["openSlots", "activateOtherLangs", "closeSlots", "deactivateOtherLangs"]
            .filter((k) => result.includes(k)) // impose manual order
            .map((value) => {
              switch (value) {
                case "closeSlots":
                  return this.clickedCloseSlots(multiple);
                case "openSlots":
                  return this.clickedOpenSlots(multiple);
                case "deactivateOtherLangs":
                  return this.clickedDeactivateOtherLangs(multiple);
                case "activateOtherLangs":
                  return this.clickedActivateOtherLangs(multiple);
                default:
                  return of(null);
              }
            })
        ).subscribe(() => this.closeClick.emit());
      });
  }

  async clickedDeactivateOtherLangs(skipConfirmation: boolean = false) {
    const shouldChangeStateSlots =
      skipConfirmation ||
      (await confirm.yesno(
        this.getSlotsPrincipalMessage("languages"),
        this.getConfirmedButtonMessageOpenSlots("languages"),
        this.getConfirmedButtonMessageCloseSlots("languages")
      ));
    if (!shouldChangeStateSlots) return;

    this.setDateAndTimeForm();
    if (!this.isLanguageBlock) {
      await this.closeAvailabilities("languages", skipConfirmation);
    }
  }

  async clickedActivateOtherLangs(skipConfirmation: boolean = false) {
    const shouldChangeStateSlots =
      skipConfirmation ||
      (await confirm.yesno(
        this.getSlotsPrincipalMessage("languages"),
        this.getConfirmedButtonMessageOpenSlots("languages"),
        this.getConfirmedButtonMessageCloseSlots("languages")
      ));
    if (!shouldChangeStateSlots) return;

    this.setDateAndTimeForm();
    if (this.isLanguageBlock) {
      await this.openAvailabilities("languages", skipConfirmation);
    }
  }

  openCrmContactPage(contactId: number | undefined) {
    if (!contactId) return;
    window.open(this.router.createUrlTree(["/contacts", contactId, this.companyInt?.id, "contact-info"]).toString(), "_blank");
  }

  filterExperiences(event: Event) {
    this._experienceSearchTerm = (event.target as HTMLInputElement).value || "";
    this.filteredExperiences = this.filteredExperiencesComputed;
    // Trigger change detection only once after filtering
    this.triggerChangeDetection();
  }

  canEditField(field: string | string[]): boolean {
    var state = this.reservation?.state;
    var type = this.reservation?.type;

    if (!this.reservation) {
      return true;
    }

    if (state === "canceled" || state === "deleted" || state === "rejected") {
      return false;
    }

    if (!this.reservation || state === "draft") {
      return true;
    }
    var permitted = true;

    if (type === "integration") {
      if (typeof field === "string" && PERMITTED_FIELDS_FOR_INTEGRATION.includes(field)) {
        // permitted fields
      } else if (Array.isArray(field) && field.every((f) => PERMITTED_FIELDS_FOR_INTEGRATION.includes(f))) {
        // permitted fields
      } else {
        return false;
      }
    }

    if (!this.internalCheckPermission(field)) {
      return false;
    }

    // PERMESSI UTENTE

    return permitted;
  }

  /**
   *
   * @param field a field name or a array (if multiple fields all must be permitted)
   * @returns true if permitted, false if at least one is not permitted
   */
  internalCheckPermission(field: string | string[]): boolean {
    if (!field) return false;

    try {
      let permissions: string[][] = [];

      if (Array.isArray(field)) {
        // Collect all permissions for the given fields
        field.forEach((f) => {
          permissions = permissions.concat(PERMISSION_MAP_WITH_FIELDS[f] || PERMISSION_MAP_WITH_FIELDS["default_permission"]);
        });
      } else if (typeof field === "string") {
        // Get permission directly for string field
        permissions = PERMISSION_MAP_WITH_FIELDS[field] || PERMISSION_MAP_WITH_FIELDS["default_permission"];
      } else {
        permissions = PERMISSION_MAP_WITH_FIELDS["default_permission"];
      }

      // Check permissions using AND for each group and OR between groups
      return evaluateReservationDetailPermissionGroups(
        this.accountsService,
        this.permissionResolver,
        permissions
      );
    } catch (e) {
      console.debug(e);
      return false;
    }
  }

  get cashRegisterSync$() {
    return this.cashRegisterService.syncReservation(this.reservation!.wineryId!, this.reservation!.id!);
  }

  get cashRegisterStatus$() {
    return this.cashRegisterService.getMetadata(IntegrationEntityTypes.RESERVATION, this.reservation!.id!);
  }

  /** WS-3531 / WS-3574: hide "Genera documento commerciale" when already issued or experience has no Punto Cassa. */
  get visibleSyncButtons() {
    const isSales =
      this.form?.get("reservation")?.get("isSales")?.value === true ||
      this.reservation?.otherData?.isSales === true ||
      this.reservation?.otherData?.isSales === "true";
    let buttons = this.syncButtons;
    if (isSales) {
      buttons = buttons.filter((button) => button.id !== "force-create-receipt");
    }
    return buttons;
  }

  private experienceHasPointOfSale(): boolean {
    const exp: any = this.experience;
    if (!exp) {
      return false;
    }
    const id =
      exp.pointOfSaleWineSuiteId ||
      exp.point_of_sale_wine_suite_id ||
      exp.details?.pointOfSaleWineSuiteId ||
      exp.details?.point_of_sale_wine_suite_id;
    return !!id;
  }

  getResCashRegisterMetadata() {
    const wineryId = this.reservation?.wineryId || this.companyId;
    if (this.reservation?.id && wineryId) {
      this.syncHelper
        .getAvailableSyncButtons$(wineryId, IntegrationEntityTypes.RESERVATION, this.reservation.id, undefined, {
          bypassAutoReceiptFlags: true,
        })
        .subscribe((buttons) => {
          this.syncButtons = buttons.map((button) => this.wrapForceCreateReceiptAction(button));
          this.cdr.markForCheck();
        });
    }

    this.cashRegisterService.isIntegrated().subscribe((x) => {
      this.regCashIntegrated = x;
      this.cdr.markForCheck();
    });
  }

  addInvoiceData() {
    if (this.isInvoiceDataReadOnly) {
      return;
    }
    this.dlg
      .open(InvoiceDataDialogComponent, {
        data: {
          invoiceData: JSON.parse(this.form.get("reservation")?.get("invoiceData")?.value ?? "{}"),
        },
        width: "700px",
        maxHeight: "90vh",
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.form.get("reservation")?.get("invoiceData")?.setValue(JSON.stringify(result));
        }
      });
  }

  private setTranslatableCSSProperties(): void {
    // Set CSS custom properties for translatable text used in CSS
    const discountCodeText = this.translate.instant("Discount Code Label");
    const truncatedText = this.truncateDiscountCodeText(discountCodeText);

    document.documentElement.style.setProperty("--discount-code-text", `"${truncatedText}"`);
  }

  private truncateDiscountCodeText(text: string): string {
    const maxLength = 14; // Lunghezza massima basata su "Codice Sconto" (12 caratteri)
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength - 3) + "...";
  }

  getDiscountCodeTooltip(): string {
    const discountCodeText = this.translate.instant("Discount Code Label");
    const truncatedText = this.truncateDiscountCodeText(discountCodeText);

    // Mostra il tooltip solo se il testo è stato troncato
    if (discountCodeText.length > 14) {
      return discountCodeText;
    }
    return "";
  }

  toggleCouponGiftSwitch(checked: boolean): void {
    this.showCouponToggle = checked;
    this.cdr.markForCheck(); // Trigger change detection for OnPush strategy
  }

  getCountryCodeForLanguage(languageCode: string): string {
    return this.dwsLanguagesService.getCountryCodeForLanguage(languageCode);
  }

  /**
   * Schedule optional data loading after MUST calls are completely done
   * This prevents server overload by ensuring MUST calls finish first
   */
  private scheduleOptionalDataLoading(reservation: any) {
    // Use requestAnimationFrame to ensure UI is fully rendered before starting optional calls
    requestAnimationFrame(() => {
      setTimeout(() => {
        console.log("🔄 [TIMING] Starting optional data loading (non-blocking) - after MUST calls completion and UI rendering");
        this.loadOptionalData(reservation);
      }, 100); // Additional small delay to prevent server overload
    });
  }

  /**
   * Schedule optional data loading for new reservations after MUST calls are completely done
   */
  private scheduleOptionalDataLoadingForNewReservation() {
    // Use requestAnimationFrame to ensure UI is fully rendered before starting optional calls
    requestAnimationFrame(() => {
      setTimeout(() => {
        console.log("🔄 [TIMING] Starting optional data loading for new reservation (non-blocking) - after MUST calls completion and UI rendering");
        this.loadOptionalDataForNewReservation();
      }, 100); // Additional small delay to prevent server overload
    });
  }

  /**
   * Load optional data without blocking the UI
   * These calls run without observe() so they don't show loading indicators
   */
  private loadOptionalData(reservation: any) {
    const optionalStartTime = performance.now();
    console.log("📡 [TIMING] Optional data loading started");

    // Load payment link data (optional)
    const paymentLinkStartTime = performance.now();
    this.wsPaymentsService
      .getPaymentLink({
        reservationId: reservation.id,
      })
      .pipe(
        tap(() => console.log("📡 [TIMING] wsPaymentsService.getPaymentLink() started")),
        catchError(() => of({ content: [] }))
      )
      .subscribe((paymentLinkPage) => {
        const paymentLinkTime = performance.now() - paymentLinkStartTime;
        console.log(`✅ [TIMING] wsPaymentsService.getPaymentLink() completed in ${paymentLinkTime.toFixed(2)}ms`);
        this.paymentLinkData = this.pickPaymentLinkForReservation(paymentLinkPage.content);

        this.applyDwspayPaymentMethodsIfNeeded();
        // Update form control states when payment link data changes
        this.updateFormControlStates();
      });

    if (reservation?.id && !this.dwspayPaymentLoading) {
      this.loadDwspayPaymentRecord(reservation.id);
    }

    // Load coupons (optional) - with local loading indicator
    const couponsStartTime = performance.now();
    this.loadingCoupons = true;
    this.hostCouponsService
      .listValidCoupons()
      .pipe(
        tap(() => console.log("📡 [TIMING] hostCouponsService.listValidCoupons() started")),
        map((coupons) => coupons ?? []),
        catchError(() => of([]))
      )
      .subscribe((coupons) => {
        const couponsTime = performance.now() - couponsStartTime;
        console.log(`✅ [TIMING] hostCouponsService.listValidCoupons() completed in ${couponsTime.toFixed(2)}ms`);
        this.availableCoupons = coupons;
        this.loadingCoupons = false;
      });

    // Load cash register + fiscality sync buttons (optional)
    const cashRegisterStartTime = performance.now();
    console.log("📡 [TIMING] getResCashRegisterMetadata() started");
    this.getResCashRegisterMetadata();
    console.log(
      `✅ [TIMING] getResCashRegisterMetadata() scheduled in ${(performance.now() - cashRegisterStartTime).toFixed(2)}ms`
    );

    // Load contact data (optional) - moved from setFormValues to avoid blocking UI
    console.log("📡 [TIMING] Loading contact data (optional)");
    this.setContactsArraysWithValues();

    const totalOptionalTime = performance.now() - optionalStartTime;
    console.log(`🎉 [TIMING] All optional data loading completed in ${totalOptionalTime.toFixed(2)}ms`);
  }

  private shouldDeferUiUntilDwspayPaymentReady(): boolean {
    if (!this.reservation?.id) {
      return false;
    }
    const state = this.reservation.state;
    const paid = this.reservation.paid || this.form?.get('reservation')?.get('paid')?.value;
    if (!paid || !(state === 'confirmed' || state === 'completed' || state === 'revoked')) {
      return false;
    }
    if (this.isDwspayPayment || this.hasDwspayPaymentEvidence()) {
      return true;
    }
    return this.paidOnline && this.isDwspayIntegrationEnabled();
  }

  private isDwspayIntegrationEnabled(): boolean {
    return !!(
      this.dwspayIntegration &&
      !this.dwspayIntegration.disabled &&
      this.dwspayIntegration.connected
    );
  }

  private finalizeInitialDwspayPaymentUiLoading(): void {
    if (this.initialPageLoadActive && this.shouldDeferUiUntilDwspayPaymentReady()) {
      this.dwspayPaymentUiTracking = true;
      if (this.reservation?.id) {
        this.loadDwspayPaymentRecord(this.reservation.id);
      }
    }
    this.syncDwspayPaymentUiLoading();
  }

  private syncDwspayPaymentUiLoading(): void {
    if (!this.mustCallsLoaded || !this.initialPageLoadActive) {
      return;
    }

    const dwspayPending =
      this.dwspayPaymentUiTracking &&
      (this.dwspayPaymentLoading || this.paymentRefundStatusLoading);

    if (!dwspayPending) {
      this.dwspayPaymentUiTracking = false;
      this.initialPageLoadActive = false;
      this.loading = false;
    }
  }

  private loadDwspayPaymentRecord(reservationId: string): void {
    if (this.initialPageLoadActive && this.shouldDeferUiUntilDwspayPaymentReady()) {
      this.dwspayPaymentUiTracking = true;
    }

    this.dwspayPaymentLoading = true;
    this.dwspayPaymentRecord = null;
    this.cdr.markForCheck();
    this.wsPaymentsService
      .getPayments({
        saleEntityType: 'reservation',
        saleEntityId: reservationId,
      })
      .pipe(
        catchError(() => of({ content: [] as Payment[] })),
        finalize(() => {
          this.dwspayPaymentLoading = false;
          if (this.initialPageLoadActive) {
            this.syncDwspayPaymentUiLoading();
          }
          this.cdr.markForCheck();
        }),
      )
      .subscribe((page) => {
        const payments = page.content ?? [];
        this.dwspayPaymentRecord =
          payments.find((p) => String(p.provider || '').toLowerCase() === 'dwspay') ??
          payments[0] ??
          null;
        this.applyDwspayPaymentMethodsIfNeeded();
        this.applyRefundStateFromDwspayRecord();
        this.cdr.markForCheck();
      });
  }

  private applyRefundStateFromDwspayRecord(): void {
    const payment = this.dwspayPaymentRecord;
    if (!payment) {
      return;
    }
    const status = String(payment.status || '').toLowerCase();
    const intent = (payment.intent ?? {}) as Record<string, any>;
    const latestCharge = typeof intent.latest_charge === 'object' && intent.latest_charge
      ? intent.latest_charge
      : (typeof intent.latestCharge === 'object' && intent.latestCharge ? intent.latestCharge : {});
    const amountRefunded = Number(
      intent.amount_refunded ??
      latestCharge.amount_refunded ??
      latestCharge.amountRefunded ??
      0
    );
    if (status !== 'refunded' && amountRefunded <= 0) {
      return;
    }
    const totalCents = this.reservation?.netTotalCents ?? 0;
    const refundedCents = amountRefunded > 0 ? amountRefunded : totalCents;
    if (this.reservation && refundedCents > 0) {
      const current =
        this.reservation.refundedTotalCents ??
        (this.reservation as any).otherData?.refundedTotalCents ??
        0;
      this.reservation.refundedTotalCents = Math.max(current, refundedCents);
    }
    this.paymentRefunded = totalCents <= 0 || refundedCents >= totalCents;
    if (this.paymentRefunded && !this.refundDate && payment.updatedAt) {
      this.refundDate = new Date(payment.updatedAt);
    }
    this.patchRefundedAmount();
  }

  /**
   * Load optional data for new reservations without blocking the UI
   */
  private loadOptionalDataForNewReservation() {
    const newReservationOptionalStartTime = performance.now();
    console.log("📡 [TIMING] New reservation optional data loading started");

    // Load coupons (optional) - with local loading indicator
    const newCouponsStartTime = performance.now();
    this.loadingCoupons = true;
    this.hostCouponsService
      .listValidCoupons()
      .pipe(
        tap(() => console.log("📡 [TIMING] hostCouponsService.listValidCoupons() started (new reservation)")),
        map((coupons) => coupons ?? []),
        catchError(() => of([]))
      )
      .subscribe((coupons) => {
        const newCouponsTime = performance.now() - newCouponsStartTime;
        console.log(`✅ [TIMING] hostCouponsService.listValidCoupons() completed in ${newCouponsTime.toFixed(2)}ms (new reservation)`);
        this.availableCoupons = coupons;
        this.loadingCoupons = false;
      });

    // Load cash register metadata (optional)
    const newCashRegisterStartTime = performance.now();
    console.log("📡 [TIMING] cashRegisterService.isIntegrated() started (new reservation)");
    this.cashRegisterService.isIntegrated().subscribe((x) => {
      const newCashRegisterTime = performance.now() - newCashRegisterStartTime;
      console.log(`✅ [TIMING] cashRegisterService.isIntegrated() completed in ${newCashRegisterTime.toFixed(2)}ms (new reservation)`);
      this.regCashIntegrated = x;
    });

    // Load contact data (optional) - moved from setFormValues to avoid blocking UI
    console.log("📡 [TIMING] Loading contact data (optional) for new reservation");
    this.setContactsArraysWithValues();

    const totalNewReservationOptionalTime = performance.now() - newReservationOptionalStartTime;
    console.log(`🎉 [TIMING] All new reservation optional data loading completed in ${totalNewReservationOptionalTime.toFixed(2)}ms`);
  }

  manageEmailSending() {
    if (this.experience && !this.masterContactControl && this.reservation) {
      this.dialogForManageEmailSending.open(ManageEmailSendingComponent, {
        data: {
          wineryId: this.companyId,
          experienceId: this.experience.id,
          externalEntityId: this.reservationId,
          isReservationCompleted: this.reservation.state === "completed"
        },
        width: "98vw",
        maxWidth: "1150px",
      });
    } else if (this.experience && this.masterContactControl && this.reservation) {
      this.dialogForManageEmailSending.open(ManageEmailSendingComponent, {
        data: {
          wineryId: this.companyId,
          experienceId: this.experience.id,
          externalEntityId: this.reservationId,
          emailAddress: this.masterContactControl.get("email")?.value,
          isReservationCompleted: this.reservation.state === "completed"
        },
        width: "98vw",
        maxWidth: "1150px",
      });
    }
  }

}

// this map is for the permissions that are to block if not permitted
const PERMISSION_MAP_WITH_FIELDS: { [key: string]: string[][] } = {
  default_permission: [["WRITE", "CALENDAR"], ["WINERY_ADMIN"]],
  date: [["RESCHEDULE_RESERVATION"], ["WINERY_ADMIN"]],
  time: [["RESCHEDULE_RESERVATION"], ["WINERY_ADMIN"]],
  change_status: [["CHANGE_STATUS_RESERVATION"], ["WINERY_ADMIN"]],
};

const PERMITTED_FIELDS_FOR_INTEGRATION = [
  "date",
  "time",
  "partecipants",
  "origin",
  "visit_reason",
  "notes",
  "room",
  "employee",
  "change_status",
  "check_in",
];

@Injectable({
  providedIn: "root",
})
class BackgroundService {
  private _busy: boolean = false;
  get busy(): boolean {
    return this._busy;
  }

  constructor(private snackBar: MatSnackBar) {
    console.log("constructing bg service");
  }

  execute<T>(args: { task: Observable<T>; message: string }): Observable<T> {
    const { task, message } = args;
    const toast = this.snackBar.open(message, undefined, {
      verticalPosition: "top",
    });
    return task.pipe(
      tap(() => {
        toast.dismiss();
        this._busy = false;
      }),
      catchError((err) => {
        toast.dismiss();
        this._busy = false;
        return throwError(err);
      })
    );
  }
}
